
import React, { Component, Fragment } from 'react';
import Input from 'Components/Input';
import FormInput from 'Components/FormInput/index';

import { ReactComponent as CloseIcon } from 'Icons/close.svg';
import { ReactComponent as TrashIcon } from 'Icons/delete.svg'
import { connect } from 'react-redux';
import Overlay from 'Components/Overlay/index';
import Heading from 'Components/Heading';
import Dropdown from "Components/Dropdown";
import { COST_TYPE, TAT_UNITS_LAT, SHOW_TAT, CHALLENGE_PRICE_SENT, COUNTER_ACCEPT, HIKAL, ADANI, VESSEL_ROUTING_TYPES } from 'Constants/commonConstants';
import Cx from 'classnames';
import { formatToINR } from 'Utils/transform';
import { ReactComponent as AcceptIcon } from 'Icons/checked.svg'
import { ReactComponent as RejectIcon } from 'Icons/reject.svg';
import PlacesAutoComplete from 'Components/PlacesAutoComplete';
import { SingleDatePicker } from 'react-dates';
import Moment from 'moment';
import TimePicker from 'rc-time-picker';
import ConfirmationPopup from 'Components/ConfirmationPopup';
import { ReactComponent as SEOIcon } from 'Icons/seo.svg';
import AddCostHeadPopup from './addCostHeadsPopup';
import { isValueThere } from "Utils/index";
import { getItemFromLocal } from 'Utils/localStorage';
import { GET_CURRENCY_DETAILS } from 'Constants/actionConstants';

class HandlingCharges extends Component {
	constructor(props) {
		super(props);
		const { leg } = props;
		const isLCL = ((leg.rfqType === 5 || [13,14,15].includes(leg.rfqType)) && leg.rfqServiceType === 5 && props.includesOtherCharges);
		const tripCost = leg && leg.legs && leg.legs.length > 0 && leg.legs[0].tripCost ? ( isLCL ? leg.multi_mode_leg_trip[0].price_volume_inr : leg.legs[0].tripCost) : 0;
		const usd = leg && (leg.multi_mode_leg_trip[0] || {})[isLCL ? 'price_volume_usd' : 'trip_cost_usd'];
		const secondaryPrice = leg && (leg.multi_mode_leg_trip[0] || {})[isLCL ? 'price_volume_secondary' : 'trip_cost_secondary'];

		this.state = {
			price: tripCost,
			price_usd:usd || secondaryPrice,
			leg: props.leg,
			tatValue: (props.leg.tat || {}).tatValue || '',
			tatUnit: {
				unit: ((props.leg.tat || {}).tatUnit || {}).tatUnit,
				name: ((props.leg.tat || {}).tatUnit || {}).tatUnitName
			},
			estimated_time_of_departure_date:'',
			estimated_time_of_arrival_date: '',
			confirmationPopup: false,
			showBreakUp: true,
			provider_bid_remarks:''
		};
	}

	getHeadingChargeBaseField = (leg, baseFieldValue) => {
		const isAdani = ADANI.includes(leg.companyId);
		let baseField = 'Base Freight';
		if([13,14].includes(leg.rfqType)) {
			baseField = 'Service Charges';
		} else if(isAdani) {
			if(leg.multi_level_movement_type == 2) {
				baseField = ((leg || {}).legType == 2) ? 'Ocean Freight' : 'Base Freight';
			} else {
				baseField = baseFieldValue
			}
		}
		return baseField;
   }

	 componentDidMount(){
		const { leg } = this.state;
		const isExim = [13,14,15].includes(leg.rfqType);
		if(isExim){
			this.currencyDetails();
		}
	 }

	 currencyDetails = () => {
			const { dispatch, rfq } = this.props;
			dispatch({
						type: GET_CURRENCY_DETAILS,
						data: {
							 companyId: rfq.companyId,
							 branchId: rfq.branchId,
							 seekerCompanyId: getItemFromLocal("transporter_seeker_company_id")
						}
			});
		};

	componentWillReceiveProps(nextProps) {
    	const { leg, includesOtherCharges } = this.props;
		const isLCL = ((leg.rfqType === 5 || [13,14,15].includes(leg.rfqType)) && leg.rfqServiceType === 5 && includesOtherCharges);
		const isNextPropsLCL = (nextProps.leg && (nextProps.leg.rfqType === 5 || [13,14,15].includes(nextProps.leg.rfqType)) && nextProps.leg.rfqServiceType === 5 && nextProps.includesOtherCharges);
		const tripCost = leg && leg.legs && leg.legs.length > 0 && leg.legs[0].tripCost ? (isLCL ? leg.multi_mode_leg_trip[0].price_volume_inr : leg.legs[0].tripCost) : 0
		const nextTripCost = nextProps.leg && nextProps.leg.legs && nextProps.leg.legs.length > 0 && nextProps.leg.legs[0].tripCost ? (isNextPropsLCL ? nextProps.leg.multi_mode_leg_trip[0]['price_volume_inr'] : nextProps.leg.legs[0].tripCost) : 0;
		const usd = nextProps.leg && nextProps.leg.multi_mode_leg_trip && nextProps.leg.multi_mode_leg_trip.length > 0 && nextProps.leg.multi_mode_leg_trip[0][isNextPropsLCL ? 'price_volume_usd' : 'trip_cost_usd'];
		const secondaryPrice = nextProps.leg && nextProps.leg.multi_mode_leg_trip && nextProps.leg.multi_mode_leg_trip.length > 0 && nextProps.leg.multi_mode_leg_trip[0][isNextPropsLCL ? 'price_volume_secondary' : 'trip_cost_secondary'];
		if(nextProps.leg !== this.props.leg && tripCost !== nextTripCost) {
			this.setState({
				price: nextTripCost,
				price_usd:usd || secondaryPrice,
			});
		};
		if (nextProps.leg && nextProps.leg.legs && nextProps.leg.legs[0] && this.state.leg && this.state.leg.legs[0] && (this.state.leg.legs[0].multiModeHeadingCharges || this.state.leg.legs[0].secondaryModeOtherCharges) && (nextProps.leg.legs[0].multiModeHeadingCharges || nextProps.leg.legs[0].secondaryModeOtherCharges) && !nextProps.isChargeEdit) {
			if(
				(JSON.stringify(nextProps.leg.legs[0].multiModeHeadingCharges) !== JSON.stringify(this.state.leg.legs[0].multiModeHeadingCharges)) ||
				(JSON.stringify(nextProps.leg.legs[0].secondaryModeOtherCharges) !== JSON.stringify(this.state.leg.legs[0].secondaryModeOtherCharges)) || (!nextProps.isChargeEdit && leg.rfqType === 3 && ['999', '872'].includes(leg.companyId) && nextProps.leg && nextProps.leg.legs && nextProps.leg.legs.length && this.state.leg && this.state.leg.extra_cost_cp_state && nextProps.leg.extra_cost_cp_state && JSON.stringify(JSON.parse(this.state.leg.extra_cost_cp_state)) !== JSON.stringify(JSON.parse(nextProps.leg.extra_cost_cp_state)))
			) {
			this.setState({
				leg: nextProps.leg
			})
		}
      } else if(nextProps.leg && nextProps.leg.legs && nextProps.leg.legs.length && this.state.leg && this.state.leg.legs && this.state.leg.legs.length &&
         (
			(nextProps.leg.legs[0].multiModeHeadingCharges && !this.state.addedCost && nextProps.leg.legs[0].multiModeHeadingCharges.length !== this.state.leg.legs[0].multiModeHeadingCharges.length)  || 
         (nextProps.leg.legs[0].secondaryModeOtherCharges && nextProps.leg.legs[0].secondaryModeOtherCharges.length !== this.state.leg.legs[0].secondaryModeOtherCharges.length))) {
         this.setState({
            leg: nextProps.leg
         })
      } else if(nextProps.leg && nextProps.leg.legs && nextProps.leg.legs.length && this.state.leg && this.state.leg.legs && !this.state.leg.legs.length ) {
         this.setState({
            leg: nextProps.leg
         })
      } 
	  if(nextProps.leg && (nextProps.leg.rfqType === 5 || [13,15,14].includes(nextProps.leg.rfqType)) && nextProps.isRilCPForm && JSON.parse(JSON.stringify(nextProps.leg)) !== JSON.parse(JSON.stringify(this.state.leg))) {
		this.setState({
            leg: nextProps.leg
         })
	  }
	}
	onHCChange = (hcIndex, value, name, isSlab) => {
		let { leg, price, price_usd } = this.state;
		const { currencyTypes, currencyDetails } = this.props;
		if (leg && leg.legs && leg.legs.length > 0) {
			let newHeadingCharge = leg.legs[0].multiModeHeadingCharges;
			const hcCurrencyType = newHeadingCharge[hcIndex] && (currencyTypes || []).find(el => el.currency_type == newHeadingCharge[hcIndex]['headingChargesUnit']) || {};
			const conversionUSDObj = (currencyDetails || []).find(currencyObj => currencyObj.name === (hcCurrencyType.currency_type === 3 ? 'EUR to INR' : 'USD to INR'));
			if (this.props.leg.rfqType === 3 && isSlab) {
				var newSlabCharge = leg.legs[0].secondaryModeOtherCharges
				newSlabCharge[hcIndex][name] = value;
			} else if(this.props.leg.rfqType === 2 || this.props.leg.rfqType === 3 ) {
				newHeadingCharge[hcIndex][name] = value;
			} else if(this.props.leg.rfqType === 5  || [13,14,15].includes(this.props.leg.rfqType)) {
				if(name === "headingChargesCp_inr") {
					newHeadingCharge[hcIndex]["headingChargesCp"] = value;
					newHeadingCharge[hcIndex][name] = value;
					newHeadingCharge[hcIndex][`headingChargesCp_${hcCurrencyType.currency_type === 3 ? 'secondary' : 'usd'}`] = (conversionUSDObj && value && (value / conversionUSDObj.rupee).toFixed(5) || value);
					if(['Base Freight','Ocean Freight', 'Service Charges'].includes(newHeadingCharge[hcIndex]['headingChargesValue'])) {
						price = value;
						price_usd = (conversionUSDObj && value && (value / conversionUSDObj.rupee).toFixed(5) || value);
					}
				} else if(["headingChargesCp_usd", "headingChargesCp_secondary"].includes(name)) {
					newHeadingCharge[hcIndex][name] = (value);
					newHeadingCharge[hcIndex]["headingChargesCp_inr"] = (conversionUSDObj && value && (value * conversionUSDObj.rupee).toFixed(5) || value);
					newHeadingCharge[hcIndex]["headingChargesCp"] = (conversionUSDObj && value && (value * conversionUSDObj.rupee).toFixed(5) || value);
					if(newHeadingCharge[hcIndex].isBaseFreight) {
						price_usd = value;
						price = (conversionUSDObj && value && (value * conversionUSDObj.rupee).toFixed(5) || value);
					}
				}
			}

			this.setState({
				leg: {
					...leg,
					multiModeHeadingCharges: newHeadingCharge,
					secondaryModeOtherCharges: newSlabCharge || [],
				},
				price,
				price_usd
			}, () => {
				this.updateDataList();
			});
		}
	}

	updateDataList = () => {
		const { leg } = this.state;
		const isHIKAL = HIKAL.includes(leg.companyId);
		const isExim = [13,14,15].includes(leg.rfqType);
		if(isHIKAL || isExim) {
			const { includesOtherCharges, handlePriceUpdateStore, currencyTypes, currencyDetails } = this.props;
			const legCurrencyType = (currencyTypes || []).find(el => el.currency_name === (leg.multi_mode_leg_trip[0].leg_cost_name !== 'INR' ? leg.multi_mode_leg_trip[0].leg_cost_name : leg.priceInBaseCurrency)) || {};
			let totalBudget = 0;
			let totalUsdBudget = 0;
			let totalInrBudget = 0;
			let total = 0;
			let usdTotal = 0
			let totalSlab = 0;
			let totalHeadingCost = 0;
			let consversionObj = {}
			if(leg.rfqType === 5 || isExim) {
				consversionObj = currencyDetails.find(currencyObj => currencyObj.name === (leg.priceInBaseCurrency === 'EUR' ? 'EUR to INR': 'USD to INR'));
			}
			if (leg.legs && leg.legs.length > 0 && leg.legs[0].multiModeHeadingCharges && leg.legs[0].multiModeHeadingCharges.length > 0) {
				leg.legs[0].multiModeHeadingCharges.map((hc, hcindex) => {
					if(leg.rfqType === 2) {
						totalBudget += parseFloat(hc.headingChargesBudget || 0);
					} else if((leg.rfqType === 5 || isExim) && ( !['Base Freight', 'Ocean Freight', 'Service Charges'].includes(hc.headingChargesValue))) {
						// totalUsdBudget += parseFloat(hc[`headingChargesCp_${legCurrencyType.currency_type === 3 ? 'secondary' : 'usd'}`] || 0);
						// totalUsdBudget += parseFloat(consversionObj && (hc.headingChargesCp_inr / consversionObj.rupee) || 0);
						totalInrBudget += parseFloat(((isHIKAL || isExim || leg.rfqServiceType === 5) ? (((isHIKAL || isExim) && hc.headingChargesBusinessVolumeUnitName === 'Per Shipment') ? hc.headingChargesCp_inr : (hc.headingChargesCp_inr * (hc.headingChargesBusinessVolumeValue || 1))) : hc.headingChargesCp_inr) || 0);
					} else if(leg.rfqType === 3) {
						totalHeadingCost += parseFloat(hc.headingChargesBudget || 0);
					}
				});
				totalUsdBudget = parseFloat(consversionObj && (totalInrBudget / consversionObj.rupee) || 0)
			}
			if (includesOtherCharges) {
				if(leg.rfqType === 2) {
					total = parseFloat(this.state.price) + parseFloat(totalBudget || 0);
				} else {
					const businessVol = ((leg.multi_mode_leg_trip[0] || {}).business_volume && leg.multi_mode_leg_trip[0].business_volume.value) || 0;
					const baseFreight = (leg.legs[0].multiModeHeadingCharges.find(hc => hc.headingChargesValue === this.getHeadingChargeBaseField(leg, hc.headingChargesValue)) || {}).headingChargesCp_inr || 0;
					total = parseFloat((isHIKAL || isExim || leg.rfqServiceType === 5) ? (((isHIKAL || isExim) ? baseFreight : this.state.price) *  businessVol) : this.state.price) + parseFloat(totalInrBudget || 0);
					usdTotal = parseFloat(consversionObj && (total / consversionObj.rupee) || 0);
					// usdTotal = parseFloat(this.state.price_usd) + parseFloat(totalUsdBudget || 0);
				}
			} else {
				const businessVol = (leg.multi_mode_leg_trip[0].business_volume && leg.multi_mode_leg_trip[0].business_volume.value) || 0;
				const baseFreight = (leg.legs[0].multiModeHeadingCharges.find(hc => hc.headingChargesValue === this.getHeadingChargeBaseField(leg, hc.headingChargesValue)) || {}).headingChargesCp_inr || 0;
				total = parseFloat((((isHIKAL || isExim)  || leg.rfqServiceType === 5) ? (((isHIKAL || isExim)  ? baseFreight : this.state.price) *  businessVol) : this.state.price || 0));
				usdTotal = parseFloat(consversionObj && (total / consversionObj.rupee) || 0);
			}

			let fromArray = [];
			let toArray = [];
			let costCharges = [];
			(leg && leg.legs[0] && leg.legs[0].secondaryModeOtherCharges || []).forEach((hc) => {
				fromArray.push(hc.from_range);
				toArray.push(hc.to_range)
			})

			if (leg.rfqType === 3 && leg && leg.legs[0]) {
				leg.legs[0].secondaryModeOtherCharges.map((hc, hcindex) => {
					costCharges.push(Number(hc.cost_charges_qbr));
					if(leg.secKmRun > leg.secUptoKM) {
						if (leg.legs[0].secondaryModeOtherCharges.length < 2) {
							totalSlab += (avgKm * parseFloat(hc.cost_charges_qbr || 0));
						}
						if (leg.legs[0].secondaryModeOtherCharges.length === 2) {
							totalSlab = (Number(toArray[0]) - (leg.secUptoKM || 0)) * Number(costCharges[0]) + ((leg.secKmRun - Number(toArray[0])) * Number(costCharges[1]))
						}
						if (leg.legs[0].secondaryModeOtherCharges.length > 2) {
							if (leg.secKmRun < toArray[toArray.length - 2]){
								totalSlab = (Number(toArray[0]) - (fromArray[0])) * Number(costCharges[0]) 
							}else{				
								totalSlab = (Number(toArray[0]) - (fromArray[0])) * Number(costCharges[0]) + ((leg.secKmRun - Number(toArray[toArray.length - 2])) * Number(costCharges[costCharges.length - 1]))
							}
							for (let i = 1; i < toArray.length - 1; i++) {
								if (Number(toArray[i]) < leg.secKmRun){
								totalSlab += ((Number(toArray[i]) - Number(toArray[i - 1])) * Number(costCharges[i]))
								}else{
									totalSlab += ((Number(leg.secKmRun) - Number(toArray[i - 1])) * Number(costCharges[i]))
									break;
								}
							}
						}
					}
					
			});
			if (includesOtherCharges) {
			total += totalSlab;
			}
			totalBudget += totalSlab;
			}
			handlePriceUpdateStore(
				((includesOtherCharges || isHIKAL || isExim) ? total : this.state.price), 
				{ ...leg, total: total, 
					other_cost: (leg.rfqType === 5 || isExim) ? totalInrBudget : totalBudget ,
					price_usd: legCurrencyType?.currency_type === 2 ? ((includesOtherCharges || isHIKAL || isExim) ? usdTotal : this.state.price_usd) : 0,
					price_secondary: legCurrencyType?.currency_type === 3 ? ((includesOtherCharges || isHIKAL || isExim) ? usdTotal : this.state.price_usd) : 0, 
					price_inr: ((includesOtherCharges || isHIKAL || isExim) ? total : this.state.price),
					base_price: this.state.price,
					base_price_usd: (legCurrencyType?.currency_type === 2 && leg.rfqServiceType === 5) ? this.state.price_usd : 0,
					base_price_secondary: (legCurrencyType?.currency_type === 3 && leg.rfqServiceType === 5) ? this.state.price_usd : 0,
				}, 
				Number(this.state.tatValue), 
				this.state.tatUnit);
		}
	}

	onSelect = (value) => {
		const { leg } = this.state;
		let tatUnit = {};
		if (value) {
			tatUnit = {
				name: value.name,
				unit: value.value,
			}
			localStorage.setItem('isPriceUpdated', 'true');
			let tat = {};
			tat = {
				unit: value.value,
				value: Number(this.state.tatValue),
				name: value.name
			}
			this.setState({
				tatUnit
			})

			this.setState({
				leg: {
					...leg,
					tat
				}
			});
		}
	}

	onChange = (e) => {

		const { leg } = this.state;
		this.setState({
			[e.currentTarget.name]: e.currentTarget.value
		});

		let tat = {};
		if (e.currentTarget.name === "tatValue") {

			tat = {
				unit: this.state.tatUnit && this.state.tatUnit.unit && this.state.tatUnit.unit.value ? this.state.tatUnit.unit.value : TAT_UNITS_LAT[0].value,
				value: Number(e.currentTarget.value),
				name: this.state.tatUnit && this.state.tatUnit.name && this.state.tatUnit.name ? this.state.tatUnit.name : TAT_UNITS_LAT[0].name
			}
		}
		this.setState({
			tat
		})
		this.setState({
			leg: {
				...leg,
				tat
			}
		});

	}

	handleChallengePrice = (type, item, tripId, otherCostType) => {
		const { leg } = this.state;
		const data = [{
			trip_id: tripId,
			is_accept: type === 'accept' ? true : false,
			liner_id: leg.linerId || undefined,
			cost_charge_id: item && item.cost_charge_id || undefined
		}]
		this.props.otherCostAcceptRejectCP(data, otherCostType);
   }
   
   getSlabValue = (from, to) => {
      let value = '';
      if(from && to) {
          value = `${from} - ${to}`;
      } else if(!from && to) {
         value = `${from} - ${to}`;
      } else if(from && !to) {
         value = from
      }
      return value;
   }

   onCancel = (confirmFlag) => {
		this.setState({
			confirmationPopup: false,
			total: '',
			totalInrBudget: '',
			confirmText: '',
			usdTotal: '',
			addedCost: confirmFlag ? false : this.state.addedCost
		})
   }

   onConfirm = () => {
		const { includesOtherCharges, handlePriceUpdate, currencyTypes } = this.props;
		const { leg, total, totalInrBudget, usdTotal } = this.state;
		const legCurrencyType = (currencyTypes || []).find(el => el.currency_name === (leg.multi_mode_leg_trip[0].leg_cost_name !== 'INR' ? leg.multi_mode_leg_trip[0].leg_cost_name : leg.priceInBaseCurrency)) || {};
		const isHIKAL = HIKAL.includes(leg.companyId);
		const isExim = [13,14,15].includes(leg.rfqType);
		const isAwl = ADANI.includes(leg.companyId);
		handlePriceUpdate(
			((includesOtherCharges || isHIKAL) ? total : this.state.price), 
			{ ...leg, total: total, 
				other_cost: (leg.rfqType === 5 || isExim) ? totalInrBudget : totalBudget ,
				price_usd: legCurrencyType?.currency_type === 2 ? ((includesOtherCharges || isHIKAL) ? usdTotal : this.state.price_usd) : 0,
				price_secondary: legCurrencyType?.currency_type === 3 ? ((includesOtherCharges || isHIKAL) ? usdTotal : this.state.price_usd) : 0, 
				price_inr: ((includesOtherCharges || isHIKAL) ? total : this.state.price),
				base_price: this.state.price,
				base_price_usd: (legCurrencyType?.currency_type === 2 && leg.rfqServiceType === 5) ? this.state.price_usd : 0,
				base_price_secondary: (legCurrencyType?.currency_type === 3 && leg.rfqServiceType === 5) ? this.state.price_usd : 0,
				provider_tat_time:leg.legs[0].provider_tat_time
			}, 
			Number(this.state.tatValue), 
			this.state.tatUnit);
		this.onCancel(true);
   }

   getHeadingChargesLabel = (hc, leg) => {
		let headingChargeLabel = hc.headingChargesValue;
		const { LegIndex, rfq } = this.props;
		const isAdani = ADANI.includes(leg.companyId);
		if(isAdani && rfq && ((rfq.rfqDetails || {}).multiLevelMovementType == 2) && ['Base Freight', 'Ocean Freight'].includes(headingChargeLabel)) {
			headingChargeLabel = (leg.legType == 2 ? 'Ocean Freight' : 'Base Freight');
		}
		return headingChargeLabel;
   }

   onClickAddCost = () => {
		let { leg, selectedCostHeads } = this.state; 
		const { currencyTypes } = this.props;
		const itemCurrency = (currencyTypes || []).find(el => el.currency_name == leg.legs[0].legCostName);
		const headCostLength = leg.legs[0].multiModeHeadingCharges.length;
		const previousCost = leg.legs[0].multiModeHeadingCharges[headCostLength - 1];
		(selectedCostHeads || []).map(costHead => {
			leg.legs[0].multiModeHeadingCharges.push({
				headingChargesValue: costHead.name,
				headingChargesID: costHead.id,
				headingChargesUnit: previousCost.headingChargesUnit,
				headingChargesUnitName: previousCost.headingChargesUnitName,
				headingChargesUnitName: previousCost.headingChargesUnitName,
				headingChargesBusinessVolumeValue: previousCost['headingChargesBusinessVolumeValue'],
				headingChargesBusinessVolumeUnitName: costHead['headingChargesBusinessVolumeUnitName'],
				headingChargesBusinessVolumeUnit: costHead['headingChargesBusinessVolumeUnit'],
				headingChargesDescription: '',
				headingChargesBudget: 0,
				isNewlyAdded: true
			});
		});
		this.setState({
			leg,
			selectedCostHeads: [],
			openCostHeadModal: false,
			addedCost: true
		})
   }

   addCostHead = () => {
		this.props.getPlantWiseCostHeads(this.openCostHeadMOdal);
   }

   openCostHeadMOdal = (planWiseCostHeads) => {
		const { leg } = this.state;
		const existingCostIds = (leg.legs[0].multiModeHeadingCharges || []).map(el => el.headingChargesID);
		const remainingCostHeads = (planWiseCostHeads || []).filter(el => !(existingCostIds.includes(el.id)));
		this.setState({
			openCostHeadModal: true,
			selectedCostHeads: [],
			costHeadsOptions: remainingCostHeads || []
		});
   }

   onCancelCostHeadModal = () => {
		this.setState({
			selectedCostHeads: [],
			openCostHeadModal: false,
			costHeadsOptions: []
		})
   }

   onSelectCostHead = (option) => {
		this.setState({
			selectedCostHeads: option
		})
   }

   deleteCostHead = (index) => {
		const { leg } = this.state;
		leg.legs[0].multiModeHeadingCharges.splice(index, 1);
		const isNewlyAddedExist = (leg.legs[0].multiModeHeadingCharges || []).find(el => el.isNewlyAdded)
		this.setState({
			leg,
			addedCost: isNewlyAddedExist
		});
   }

   getConfirmationText = (hcList, totalHc, mandatoryBid) => {
		const { leg } = this.state;
		const isAdani = ADANI.includes(leg.companyId);
		if(isAdani && (mandatoryBid || []).length > 0) {
			return 'Please Bid For Mandatory Cost Head';
		}
		if(isAdani && totalHc == hcList.length) {
			return 'Please Bid For Atleast One Cost Head';
		}
		if(hcList.length > 0) {
			return 'You Have Not Bid For All The Line Items, Are You Sure?';
		}
		return 'Are You Sure?';
   }

	isSubmitDisabled=(isExim)=>{
		const { currencyDetails } = this.props;
		if(isExim && (!currencyDetails || currencyDetails.length === 0)){
			return true;
		}
		return false;
	}


	shouldSkipPriceCheckForAwlEximIncoTermsFOB = (rfq) => {
		const { companyId, type, eximIncoTerms } = rfq;
		const isExim = type === 15;
		const isAdani = ADANI.includes(companyId);
		const isFOB = eximIncoTerms === "FOB";

		if (isExim && isAdani && isFOB) {
			return false;
		}

		return true;
	}

	determineBidIncrementorDecrementpercentageAmount=(rfq,baseOrOceanFreigt)=>{
		if(rfq.bid_increment_percentage_type && rfq.bid_increment_percentage){
			if(rfq.bid_increment_percentage_type==="Increase"){
				const resultInr = parseFloat(baseOrOceanFreigt.original_headingChargesCp_inr) + parseFloat((baseOrOceanFreigt.original_headingChargesCp_inr * parseFloat(rfq.bid_increment_percentage/100)));
				const resultUsd = parseFloat(baseOrOceanFreigt.original_headingChargesCp_usd) + parseFloat((baseOrOceanFreigt.original_headingChargesCp_usd * parseFloat(rfq.bid_increment_percentage/100)));

				return{
					inr : resultInr || undefined,
					usd : resultUsd || undefined,
				}
			}
			if(rfq.bid_increment_percentage_type==="Decrease"){
				const resultInr = parseFloat(baseOrOceanFreigt.original_headingChargesCp_inr) - parseFloat((baseOrOceanFreigt.original_headingChargesCp_inr * parseFloat(rfq.bid_increment_percentage/100)));
				const resultUsd = parseFloat(baseOrOceanFreigt.original_headingChargesCp_usd) - parseFloat((baseOrOceanFreigt.original_headingChargesCp_usd * parseFloat(rfq.bid_increment_percentage/100)));

				return{
					inr : resultInr || undefined,
					usd : resultUsd || undefined,
				}
			}
		}
		return null
	}
	shouldCheckForBidIncrementTolerence = (baseOrOceanFreigtObj)=>{
		const { leg } = this.state;
		const isAdani = ADANI.includes(leg.companyId);
		const {rfq} = this.props;
		if (isAdani && isValueThere(baseOrOceanFreigtObj) && isValueThere(rfq.bid_increment_percentage_type)){
			return true;
		}
		return false;
	}

	render() {
		const {
			tatUnit,
			tatValue
		} = this.state;
		const { isEditBaseRate, isChargeEdit, includesOtherCharges, showTat, isRilCPForm, currencyDetails, currencyTypes, rfq, seaAndAirLines, allowTransporterToAddCostHeadDuringBidding } = this.props;
		const { leg } = this.state;
		console.log('leg:', leg)
		const isHIKAL = HIKAL.includes(leg.companyId);
		const isExim = [13,14,15].includes(leg.rfqType);
		const isAdani = ADANI.includes(leg.companyId);
      // const hasCharges = leg.legs && leg.legs.length > 0 && leg.legs[0].multiModeHeadingCharges && leg.legs[0].multiModeHeadingCharges.length > 0 
      // && leg.legs[0].multiModeHeadingCharges[0].headingChargesValue && leg.legs[0].multiModeHeadingCharges[0].headingChargesValue.length > 0
		let totalBudget = 0;
		let totalUsdBudget = 0;
		let totalInrBudget = 0;
		let total = 0;
		let usdTotal = 0
		let totalSlab = 0;
		let totalHeadingCost = 0;
		let legCurrencyType = {};
		let totalChargableWeight = 0, totalGrossWeight = 0, totalNetWeight = 0, totalVolumeWeight = 0;
		if(leg.multi_mode_leg_trip && leg.multi_mode_leg_trip.length > 0) {
			console.log('currencyTypes:', currencyTypes)
			legCurrencyType = (currencyTypes || []).find(el => el.currency_name === ((leg.multi_mode_leg_trip[0].leg_cost_name !== 'INR') ? leg.multi_mode_leg_trip[0].leg_cost_name : leg.priceInBaseCurrency)) || {}
		}
		let avgKm = leg && leg.rfqType === 3 && (parseFloat((leg.secKmRun || 0)) - parseFloat(leg.secUptoKM || 0)) || 0;
		if (isEditBaseRate) {
			let consversionObj = {}
			if(leg.rfqType === 5 || isExim) {
				consversionObj = currencyDetails.find(currencyObj => currencyObj.name === (leg.priceInBaseCurrency === 'EUR' ? 'EUR to INR': 'USD to INR'));
			}
			if (leg.legs && leg.legs.length > 0 && leg.legs[0].multiModeHeadingCharges && leg.legs[0].multiModeHeadingCharges.length > 0) {
				leg.legs[0].multiModeHeadingCharges.map((hc, hcindex) => {
					if(leg.rfqType === 2) {
						totalBudget += parseFloat(hc.headingChargesBudget || 0);
					} else if((leg.rfqType === 5 || isExim) && !['Base Freight', 'Ocean Freight', 'Service Charges'].includes(hc.headingChargesValue)) {
						// totalUsdBudget += parseFloat(hc[`headingChargesCp_${legCurrencyType.currency_type === 3 ? 'secondary' : 'usd'}`] || 0);
						// totalUsdBudget += parseFloat(consversionObj && (hc.headingChargesCp_inr / consversionObj.rupee) || 0);
						totalInrBudget += parseFloat(((isHIKAL || isExim || leg.rfqServiceType === 5) ? (((isHIKAL || isExim) && hc.headingChargesBusinessVolumeUnitName === 'Per Shipment') ? hc.headingChargesCp_inr : (hc.headingChargesCp_inr * (isAdani ? 1 : (hc.headingChargesBusinessVolumeValue || 1)))) : hc.headingChargesCp_inr) || 0);
					} else if(leg.rfqType === 3) {
						totalHeadingCost += parseFloat(hc.headingChargesBudget || 0);
					}
				});
				totalUsdBudget = parseFloat(consversionObj && (totalInrBudget / consversionObj.rupee) || 0)
			}
			if (includesOtherCharges) {
				if(leg.rfqType === 2) {
					total = parseFloat(this.state.price) + parseFloat(totalBudget || 0);
				} else {
					const businessVol = (leg.multi_mode_leg_trip[0].business_volume && leg.multi_mode_leg_trip[0].business_volume.value) || 0;
					const baseFreight = (leg.legs[0].multiModeHeadingCharges.find(hc => (hc.isBaseFreight || ['Base Freight', 'Ocean Freight', 'Service Charges'].includes(hc.headingChargesValue))) || {}).headingChargesCp_inr || 0;
					total = parseFloat((isHIKAL || isExim || leg.rfqServiceType === 5) ? (((isHIKAL || isExim) ? baseFreight : this.state.price) *  (isAdani ? 1 : businessVol)) : this.state.price) + parseFloat(totalInrBudget || 0);
					usdTotal = parseFloat(consversionObj && (total / consversionObj.rupee) || 0);
					// usdTotal = parseFloat(this.state.price_usd) + parseFloat(totalUsdBudget || 0);
				}
			} else {
				const businessVol = ((leg.multi_mode_leg_trip[0] || {}).business_volume && leg.multi_mode_leg_trip[0].business_volume.value) || 0;
				const baseFreight = (((leg.legs[0] || {}).multiModeHeadingCharges || []).find(hc => (hc.isBaseFreight || ['Base Freight', 'Ocean Freight', 'Service Charges'].includes(hc.headingChargesValue))) || {}).headingChargesCp_inr || 0;
				total = parseFloat(((isHIKAL || isExim || leg.rfqServiceType === 5) ? (((isHIKAL || isExim) ? baseFreight : this.state.price) *  (isAdani ? 1 : businessVol)) : this.state.price || 0));
				usdTotal = parseFloat(consversionObj && (total / consversionObj.rupee) || 0);
        	}
					
					let fromArray = [];
					let toArray = [];
			let costCharges = [];
			(leg && leg.legs[0] && leg.legs[0].secondaryModeOtherCharges || []).forEach((hc) => {
				fromArray.push(hc.from_range);
				toArray.push(hc.to_range)
			})
			
			if (leg.rfqType === 3 && leg && leg.legs[0]) {
				leg.legs[0].secondaryModeOtherCharges.map((hc, hcindex) => {
					costCharges.push(Number(hc.cost_charges_qbr));
					if(leg.secKmRun > leg.secUptoKM) {
						if (leg.legs[0].secondaryModeOtherCharges.length < 2) {
							totalSlab += (avgKm * parseFloat(hc.cost_charges_qbr || 0));
						}
						if (leg.legs[0].secondaryModeOtherCharges.length === 2) {
							totalSlab = (Number(toArray[0]) - (leg.secUptoKM || 0)) * Number(costCharges[0]) + ((leg.secKmRun - Number(toArray[0])) * Number(costCharges[1]))
						}
						if (leg.legs[0].secondaryModeOtherCharges.length > 2) {
							if (leg.secKmRun < toArray[toArray.length - 2]){
								totalSlab = (Number(toArray[0]) - (fromArray[0])) * Number(costCharges[0]) 
							}else{				
								totalSlab = (Number(toArray[0]) - (fromArray[0])) * Number(costCharges[0]) + ((leg.secKmRun - Number(toArray[toArray.length - 2])) * Number(costCharges[costCharges.length - 1]))
							}
							for (let i = 1; i < toArray.length - 1; i++) {
								if (Number(toArray[i]) < leg.secKmRun){
								totalSlab += ((Number(toArray[i]) - Number(toArray[i - 1])) * Number(costCharges[i]))
								}else{
									totalSlab += ((Number(leg.secKmRun) - Number(toArray[i - 1])) * Number(costCharges[i]))
									break;
								}
							}
						}
					}
					
				});
				if (includesOtherCharges) {
					total += totalSlab;
				}
				totalBudget += totalSlab;
			}
		}
		const symbolsArr = ["e", "E", "+", "-", "."];
		const conversionUSDObj = currencyDetails.find(currencyObj => currencyObj.name === (legCurrencyType?.currency_type === 3 ? 'EUR to INR': 'USD to INR'));
		let isDedicated=1;
		if(leg && leg.rfqType === 3){
			isDedicated =(leg.legs.length>0 && leg.legs[0][['999','872'].includes(leg.companyId) ? 'multiModeHeadingCharges' : 'secondaryModeOtherCharges'].length);
		}
		console.log('leg', leg);
		console.log('legCurrencyType:', legCurrencyType)
		return (
         
			<div className="box-shadow br-5 pr flex handling-charges" >
				<div className="pt-10 pb-10 col-1">
					<div className="pl-30 pr-20 pb-10">
						<div className="flex flex-middle border-bottom-light pb-10 mb-10">
							<label className="fs-16 fBold flex-1 header-dark-color"> Cost Break Up </label>
							{(isHIKAL || isExim) && <div className={'theme-color curP fs-14 fBold'} onClick={() => this.setState({ showBreakUp: !this.state.showBreakUp})}>{`${this.state.showBreakUp ? 'Hide' : 'View'} Cost Break Up`}</div>}
						</div>
						<div className="mb-5">
							{isEditBaseRate &&
								<Fragment><div className="mb-25 flex">
									<div className={Cx("flex mr-20", {
										'wt-900': leg.rfqServiceType !== 5,
										'wt-80p': leg.rfqServiceType === 5
									})}>
									{(leg.rfqType === 2 || leg.rfqType === 3) ? <div className={'mr-10 inBlock base-rate wt-950'}>
											<div className="flex">
												<label className='fs-16 mr-5 wt-120'> Base Rate: </label>
												₹ <Input
													type="number"
													value={(leg.rfqType === 5 || isExim) ? (['USD', 'EUR'].includes(leg.multi_mode_leg_trip[0].leg_cost_name) && this.state.price && Number(this.state.price).toFixed(2) || this.state.price || '')  :(this.state.price || '')}
													placeholder="Base Rate"
													name={"headingChargesValue"}
													className={Cx('handling-Input fs-14 mt--2 handling-charges-ip', {
														'ht-25': ((leg.rfqType === 5 || isExim) && (['USD', 'EUR'].includes(leg.multi_mode_leg_trip[0].leg_cost_name)))
													})}
													onChange={(e) => {((leg.rfqType === 5 || isExim) ? (this.setState({ price: (e.target.value), price_usd: (e.target.value && conversionUSDObj && ((e.target.value) / conversionUSDObj.rupee).toFixed(5) || e.target.value)})) : (this.setState({ price: e.target.value})))}}
													noTransition={true} 
													step="any"
													containerClassName="no-transition-container"
													readOnly={!isChargeEdit}
													disabled={((leg.rfqType === 5 || isExim) && (['USD', 'EUR'].includes(leg.multi_mode_leg_trip[0].leg_cost_name))) ? true : false}
													onKeyDown={e => (symbolsArr.includes(e.key)) && e.preventDefault()}
												/>
												{(leg.rfqType === 5 || isExim) && <div className="flex">
													$<Input
														type="number"
														value={this.state.price_usd && (leg.multi_mode_leg_trip[0].leg_cost_name === "INR") && Number(this.state.price_usd).toFixed(2) || this.state.price_usd}
														placeholder="Base Rate"
														name="headingChargesValueUsd"
														className={Cx('handling-Input fs-14 mt--2 handling-charges-ip', {
															'ht-25': ((leg.rfqType === 5 || isExim) && (leg.multi_mode_leg_trip[0].leg_cost_name === "INR"))
														})}
														onChange={(e) => { this.setState({ price_usd: (e.target.value), price: (e.target.value  && conversionUSDObj && (e.target.value * conversionUSDObj.rupee).toFixed(5)) || e.target.value }); }}
														noTransition={true}
														step="any"
														containerClassName="no-transition-container"
														readOnly={!isChargeEdit}
														disabled={((leg.rfqType === 5 || isExim) && (leg.multi_mode_leg_trip[0].leg_cost_name === "INR")) ? true : false}
														onKeyDown={e => (symbolsArr.includes(e.key)) && e.preventDefault()}
													/>
												</div>}
											</div>
											{rfq.type === 3 && ['999','872'].includes(leg.companyId) &&
											 <div className="flex">
												<label className='fs-16 mr-5 wt-150'>Extra cost/km: </label>
												₹ <Input
													type="number"
													value={leg.extraCostPerKmPrice}
													placeholder="Extra cost/km"
													name={"extraCostPerKmPrice"}
													className={'handling-Input fs-14 mt--2 handling-charges-ip'}
													onChange={(e) => { 
														const { leg } = this.state;
														leg['extraCostPerKmPrice'] = e.target.value;
														this.setState({ leg });
													}}
													noTransition={true}
													step="any"
													containerClassName="no-transition-container"
													readOnly={!isChargeEdit}
													onKeyDown={e => (symbolsArr.includes(e.key)) && e.preventDefault()}
												/>
												{
													isRilCPForm &&
													<div className="wt-150 challenge-color flex fs-14 pr">
														{
															leg.extra_cost_per_km_cp &&
															formatToINR(leg.extra_cost_per_km_cp) || ''}
														{
															formatToINR(leg.extra_cost_per_km_cp) && leg.extra_cost_per_km_cp !== 0 &&
															leg.extra_cost_per_km_cp < leg.extraCostPerKmPrice &&
															leg.extra_cost_per_km_cp !== undefined &&
															leg.extra_cost_cp_state === CHALLENGE_PRICE_SENT &&
															// rfq.challengePriceWithAcceptOrReject &&
															// lineItem.counterStatus !== COUNTER_ACCEPT &&
															leg.isAccept !== true && leg.isLoiWithCPSent !== true &&

															// !this.state.hideChallengePriceApprovals.includes(lineItem.id) &&
															<React.Fragment>
																<AcceptIcon className="wt-20 ht-20 ml-5 curP z-100" onClick={() => this.handleChallengePrice('accept', null, leg.id, 'extra_cost_list') } />
																<RejectIcon className="wt-20 ht-20 ml-5 curP z-100" onClick={() => this.handleChallengePrice('reject', null, leg.id, 'extra_cost_list') }/>
															</React.Fragment>
														}
													</div>
												}
											</div>}
											{/* <div className="flex mt-5">
												<label className='fs-16 mr-5 wt-120 truncate-long-text' title="Ceiling Price">Ceiling Price : </label>
												₹ <Input
													type="number"
													value={leg.multi_mode_leg_trip[0].leg_budget_cp_inr && Number(leg.multi_mode_leg_trip[0].leg_budget_cp_inr).toFixed(2)}
													placeholder="Base Rate"
													name={"headingChargesValue"}
													className={Cx('handling-Input fs-14 mt--2 handling-charges-ip ht-25')}
													onChange={(e) => { (leg.rfqType === 5 ? (this.setState({ price: (e.target.value), price_usd: (e.target.value && conversionUSDObj && ((e.target.value) / conversionUSDObj.rupee).toFixed(5) || e.target.value)})) : (this.setState({ price: e.target.value})))}}
													noTransition={true}
													step="any"
													disabled={true}
													containerClassName="no-transition-container"
												/>
												$ <Input
													type="number"
													value={leg.multi_mode_leg_trip[0].leg_budget_cp_usd && Number(leg.multi_mode_leg_trip[0].leg_budget_cp_usd).toFixed(2)}
													placeholder="Base Rate"
													name={"headingChargesValue"}
													className={Cx('handling-Input fs-14 mt--2 handling-charges-ip ht-25')}
													onChange={(e) => { (leg.rfqType === 5 ? (this.setState({ price: (e.target.value), price_usd: (e.target.value && conversionUSDObj && ((e.target.value) / conversionUSDObj.rupee).toFixed(5) || e.target.value)})) : (this.setState({ price: e.target.value})))}}
													noTransition={true}
													step="any"
													disabled={true}
													containerClassName="no-transition-container"
												/>
											</div> */}
										</div>:
											<div>
											<div className="flex base-rate ml--10">
												{!(isAdani && isExim) && <>
													<div className="wt-70 ht-20 ml-10">
														<div className="fSemibold fs-14 header-medium-color">Currency</div>
														<div className="wt-110 ht-20 flex mt-5 fs-14">
															{(leg.multi_mode_leg_trip[0] || {}).leg_cost_name}
														</div>
													</div>
													{(isHIKAL || isExim) && <div className="wt-70 ht-20 ml-10">
														<div className="fSemibold fs-14 header-medium-color">UOM</div>
														<div className="ht-20 flex mt-5 fs-14 break-word">
															{((leg.multi_mode_leg_trip[0] || {}).business_volume || {}).name}
														</div>
													</div>}
												</> || ''}
												{(leg.rfqType === 5 || isExim) && ((isHIKAL || isExim) ? true : leg.rfqServiceType === 5) && <div className={Cx("ht-20 ml-10", {
													'wt-150': (isHIKAL || (isExim && !isAdani)),
													'wt-100': !(isHIKAL || isExim),
													'wt-200': isAdani && isExim
												})}>
													<div className="fSemibold fs-14 header-medium-color">{((isHIKAL || isExim) && !isAdani) ? (((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType == 4) ? 'No. of Containers': 'Chargeable Weight') : (isAdani ? 'Gross Volume Per Container' : 'Business Vol')}</div>
													<div className="ht-20 flex mt-5 fs-14 break-word">
														{(leg.multi_mode_leg_trip[0] || {}).business_volume && leg.multi_mode_leg_trip[0].business_volume.value} {(isHIKAL || isExim) ? '' : leg.multi_mode_leg_trip[0].business_volume.name}
														{(isAdani && isExim) && <>{((leg.multi_mode_leg_trip[0] || {}).business_volume || {}).name}</> || ''}
														{(isHIKAL || isExim) && ((rfq.rfqDetails || {}).serviceCategoryType === 2 || (rfq.rfqDetails || {}).serviceType == 5) && <SEOIcon className="curP fBold fs-18 wt-20 ht-30 mt--5" onClick={(e) => { this.setState({ openPopup: true }) }}></SEOIcon>}
													</div>
												</div>}
												{(isAdani && isExim) && <div className="wt-120 ht-20 ml-10">
													<div className="fSemibold fs-14 header-medium-color">No. Of Containers</div>
													<div className="ht-20 flex mt-5 fs-14 break-word">
														{leg.noOfContainers || '-'}
													</div>
												</div>}
												{
													(isHIKAL || isExim) && !(((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType == 4)) &&
													<>
														<div className="wt-110 ht-20">
															<div className="fSemibold fs-14 header-medium-color ">Quantity</div>
															<div className="wt-110 ht-20 flex mt-3">
																{(leg.cargoParticularList || []).reduce((sum, el) => sum += Number(el.quantity), 0)}
															</div>
														</div>
														<div className="wt-110 ht-20">
															<div className="fSemibold fs-14 header-medium-color ">Net Weight</div>
															<div className="wt-110 ht-20 flex mt-3">
																{(leg.cargoParticularList || []).reduce((sum, el) => sum += Number(el.netWeight), 0)}
															</div>
														</div>
														<div className="wt-110 ht-20">
															<div className="fSemibold fs-14 header-medium-color ">Gross Weight</div>
															<div className="wt-110 ht-20 flex mt-3">
																{(leg.cargoParticularList || []).reduce((sum, el) => sum += Number(el.grossWeight), 0)}
															</div>
														</div>
													</>
												}
												{!(isHIKAL || isExim) && <>
												<div className="wt-110 ht-20">
													<div className="fSemibold fs-14 header-medium-color ">Ceiling Price(INR)</div>
													<div className="wt-110 ht-20 flex mt-3">
														₹ {leg.multi_mode_leg_trip[0]?.leg_budget_cp_inr?.toFixed(2)}
													</div>
												</div>
												<div className="wt-120 ht-20 ml-10">
													<div className="fSemibold fs-14 header-medium-color">{`Ceiling Price(${legCurrencyType?.currency_name || ''})`}</div>
													<div className="wt-110 ht-20 flex mt-5">

														{legCurrencyType?.currency_symbol || ''}{leg?.multi_mode_leg_trip[0]?.[`leg_budget_cp_${legCurrencyType?.currency_name === 'USD' ? 'usd' : 'secondary'}`]?.toFixed(2)}
													</div>
												</div>
												</>}
												{!(isHIKAL || isExim) &&<>
												<div className="wt-110 ht-20 ml-10">
													<div className="fSemibold fs-14 header-medium-color">Base Rate(INR)</div>
													<div className="wt-120 ht-20 flex mt-5">
														₹ <Input
															type="number"
															value={(leg.rfqType === 5 || isExim) ? (leg.multi_mode_leg_trip[0].leg_cost_name !== "INR" && this.state.price && Number(this.state.price).toFixed(2) || this.state.price || '') : (this.state.price || '')}
															placeholder="Base Rate"
															name={"headingChargesValue"}
															className={Cx('handling-Input fs-14 mt--2 handling-charges-ip', {
																'ht-25': ((leg.rfqType === 5 || isExim) && (leg.multi_mode_leg_trip[0].leg_cost_name !== 'INR'))
															})}
															onChange={(e) => { 
																const conversionUSDObj = currencyDetails.find(currencyObj => currencyObj.name === (legCurrencyType?.currency_name === 'EUR' ? 'EUR to INR': 'USD to INR'));
																((leg.rfqType === 5 || isExim) ? (this.setState({ price: (e.target.value), price_usd: (e.target.value && conversionUSDObj && ((e.target.value) / conversionUSDObj.rupee).toFixed(5) || e.target.value) })) : (this.setState({ price: e.target.value }))) 
															}}
															noTransition={true}
															step="any"
															containerClassName="no-transition-container"
															readOnly={!isChargeEdit}
															disabled={((leg.rfqType === 5 || isExim) && (['USD', 'EUR'].includes(leg.multi_mode_leg_trip[0].leg_cost_name))) ? true : false}
															onKeyDown={e => (symbolsArr.includes(e.key)) && e.preventDefault()}
														/>
													</div>
												</div>
												{legCurrencyType?.currency_name !== 'INR' && <div className="wt-110 ht-20 ml-10">
													<div className="fSemibold fs-14 header-medium-color">{`Base Rate(${legCurrencyType?.currency_name || ''})`}</div>
													<div className="wt-110 ht-20 flex mt-5">
													{legCurrencyType?.currency_symbol || ''}
														<Input
															type="number"
															value={this.state.price_usd && (leg.multi_mode_leg_trip[0].leg_cost_name === "INR") && Number(this.state.price_usd).toFixed(2) || this.state.price_usd}
															placeholder="Base Rate"
															name="headingChargesValueUsd"
															className={Cx('handling-Input fs-14 mt--2 handling-charges-ip', {
																'ht-25': ((leg.rfqType === 5 || isExim) && (leg.multi_mode_leg_trip[0].leg_cost_name === "INR"))
															})}
															onChange={(e) => { 
																const conversionUSDObj = currencyDetails.find(currencyObj => currencyObj.name === (legCurrencyType?.currency_name === 'EUR' ? 'EUR to INR': 'USD to INR'));
																this.setState({ price_usd: (e.target.value), price: (e.target.value && conversionUSDObj && (e.target.value * conversionUSDObj.rupee).toFixed(5)) || e.target.value }); 
															}}
															noTransition={true}
															step="any"
															containerClassName="no-transition-container"
															readOnly={!isChargeEdit}
															disabled={((leg.rfqType === 5 || isExim) && (leg.multi_mode_leg_trip[0].leg_cost_name === "INR")) ? true : false}
															onKeyDown={e => (symbolsArr.includes(e.key)) && e.preventDefault()}
														/>
													</div>
												</div>}
												</>}
												{/* {leg.rfqType === 5 && leg.rfqServiceType === 5 &&
													<div className="wt-100 ht-20 ml-10">
													<div className="fSemibold fs-14 header-medium-color">{'Total'}</div>
													<div className="ht-20 flex mt-5">
														<div>{'₹'}{Number(this.state.price || 0) * Number(leg.multi_mode_leg_trip[0].business_volume && leg.multi_mode_leg_trip[0].business_volume.value || 0)}</div>
														<div className="mt-2 ml-5">{legCurrencyType.currency_symbol || ''}{(Number(this.state.price_usd || 0) * Number(leg.multi_mode_leg_trip[0].business_volume && leg.multi_mode_leg_trip[0].business_volume.value || 0)).toFixed(2)}</div>
													</div>
												</div>
												} */}
												</div>
											</div>}
											{
												isRilCPForm && leg.rfqType === 5 && !(isHIKAL || isExim) &&
												<div className="wt-110 ht-20 ml-10">
													<div className="fSemibold fs-14 header-medium-color">Challenge Price</div>
													{/* <div className="wt-110 ht-20 flex mt-5 challenge-color flex-1 fs-14 lh-15p pr pl-15"> */}
												 <div className="flex-1 lh-15p pr ht-20 challenge-color mt-5">
													{formatToINR(leg.challengePrice)}
													{leg[`challengePrice${legCurrencyType?.currency_name === 'USD' ? 'USD' : 'Secondary'}`] && <span className="ml-5 mr-5">{legCurrencyType?.currency_symbol || ''}{leg[`challengePrice${legCurrencyType?.currency_name === 'USD' ? 'USD' : 'Secondary'}`]}</span>}
													{
														formatToINR(leg.challengePrice) && leg.challengePrice !== 0 &&
														leg.challengePrice < leg.price &&
														leg.challengePrice !== undefined &&
														leg.cpState === CHALLENGE_PRICE_SENT && rfq.challengePriceWithAcceptOrReject &&
														leg.counterStatus !== COUNTER_ACCEPT &&
														leg.isAccept !== true && leg.isLoiWithCPSent !== true &&
									
														// !this.state.hideChallengePriceApprovals.includes(lineItem.id) &&
														<React.Fragment>
															<AcceptIcon className="wt-20 ht-20 ml-5 curP z-100" onClick={() => this.props.handleChallengePrice('accept', leg)} />
															<RejectIcon className="wt-20 ht-20 ml-5 curP z-100" onClick={() => this.props.handleChallengePrice('reject', leg)} />
														</React.Fragment>
													}
												</div>
												</div>
											}
										<div className="flex wt-600 ">
											{showTat && <div className="inBlock flex ml-5">
												<label className='fs-16 ml-15'> TAT: </label>
												<Input
													type="number"
													placeholder="TAT"
													name="tatValue"
													value={tatValue}
													className={'handling-Input fs-14 mt--2 handling-charges-ip'}
													noTransition={true}
													containerClassName="no-transition-container"
													onChange={this.onChange}
												/>
											</div>}
											{showTat && <div className="ml-5 mt--10 inBlock flex">
												<Dropdown
													items={TAT_UNITS_LAT}
													selectedItem={tatUnit.name ? tatUnit : TAT_UNITS_LAT[0]}
													name="tatUnit"
													displayKey="name"
													label=""
													noBorder={true}
													className={'fs-12 mt--2 handling-charges-ip'}
													onSelect={this.onSelect}
												/>
											</div>}
										</div>
									
										{<div className={(leg.rfqType === 5  || isExim) ? "inBlock flex ml-10 wt-7000" : "inBlock flex ml-10 wt-950"}>
											{['999','872'].includes(leg.companyId) && <label className='fs-16 truncate-long-text' title={`${(leg.rfqType === 2) ? 'Total Bid Cost' : ((leg.rfqType === 5 || isExim) ? 'Total Other Costs' :'Total Slab Cost')}`}> {`${(leg.rfqType === 2) ? 'Total Bid Cost' : ((leg.rfqType === 5 || isExim) ? 'Total Other Costs' :'Total Slab Cost')}:`}</label>}
											<div className={((leg.rfqType === 5 && isRilCPForm) || leg.rfqServiceType === 5) ? "" : "flex"}>
											{['999','872'].includes(leg.companyId) && <div className="fs-14 fBold">₹ {((leg.rfqType === 5 || isExim) ? totalInrBudget.toFixed(2) : (leg.rfqType === 3 ? totalSlab : totalBudget)) || 0}</div>}
											{(leg.rfqType === 5  || isExim) && leg.priceInBaseCurrency !== 'INR' && <div className="fs-14 fBold mt-4 ml-10">{leg.priceInBaseCurrencySymbol || ''} {totalUsdBudget.toFixed(2) || 0}</div>	}
											</div>
										</div>}
                              		{leg.rfqType === 3 && <div className="inBlock flex ml-10 wt-800">
											<label className='fs-16'> Total Heading Cost: </label>
											<div className="fs-14 fBold">₹ {totalHeadingCost || 0}</div>
										</div>}
									</div>
								<div className="flex flex-column ml--30">
									{<div className={!(leg.rfqType === 5 || isExim) ? "flex wt-600" : "flex wt-270"}>
											<label className='fs-16 truncate-long-text' title={'Total Price'}> Total Price: </label>
											<div className="flex">
											<div className="fs-14 fBold mr-15">₹ {total ? total.toFixed(2) : 0}</div>
											{(leg.rfqType === 5  || isExim) && leg.priceInBaseCurrency !== 'INR' && <div className="fs-14 fBold mt-4">{leg.priceInBaseCurrencySymbol || '$'} {usdTotal ? usdTotal.toFixed(2) : 0}</div>}
											</div>
										</div>}
										<div>
										{leg.rfqType === 3 && !['999','872'].includes(leg.companyId) &&  <div className="fs-11 "> *This {includesOtherCharges ? 'Includes' : 'Excludes'} Total Slab Costs. </div>}
										{(leg.rfqType === 2 || (leg.rfqType === 5  || isExim)) && <div className="fs-11"> *This {includesOtherCharges ? 'Includes' : 'Excludes'} Total Costs. </div>}
										</div>
									</div>
								</div>
								
								</Fragment>
							}
							{((isHIKAL || isExim) ? this.state.showBreakUp : true) && <div className={Cx("flex", {"pt-20": (isHIKAL || isExim) })}>
							<div className={Cx("", {
								'wt-60p': !isChargeEdit && (isHIKAL || [15].includes(leg.rfqType) || (rfq.shippingType !== 1 && [5,15].includes(leg.rfqType))),
								'col-2': isChargeEdit && ([13,14].includes(leg.rfqType) ? rfq.shippingType !== 1 : ![15].includes(leg.rfqType)),
								'col-1': isChargeEdit && ([13,14].includes(leg.rfqType) ? rfq.shippingType === 1 : false),
								'wt-70p': isChargeEdit && [15].includes(leg.rfqType)
							})}>
							<div className="flex">
								<div className="flex mb-10">
									{((isDedicated> 0 &&  ['999','872'].includes(leg.companyId)) && !isExim) && <div className="wt-20 ht-20 mr-5">
										<div className="fSemibold fs-14 header-medium-color mb-5"></div>
									</div>}


                          {isDedicated> 0 && <div className={Cx("ht-20 border-bottom-light", {
										'wt-80': ([5, 15].includes(leg.rfqType) || (rfq.shippingType !== 1 && [13,14].includes(leg.rfqType))),
										'wt-100': leg.rfqType === 2,
										'wt-250': leg.rfqType === 3 || (rfq.shippingType == 1 && [13,14].includes(leg.rfqType)),
										'wt-200': [15].includes(leg.rfqType)
									})}>
										<div className="fSemibold fs-14 header-medium-color mb-5">Cost Head </div>
									</div>}

									{leg.rfqType !== 3 ?
										<Fragment>
											<div className="wt-65 ht-20 border-bottom-light">
												<div className="fSemibold fs-14 header-medium-color mr-5">Currency</div>
											</div>
											{leg.rfqType === 5 && leg.rfqServiceType === 5 && !(isHIKAL || isExim) && 
											<div className="wt-100 ht-20 border-bottom-light">
												<div className="fSemibold fs-14 header-medium-color mr-5">Business Vol</div>
											</div>}
											{(leg.rfqType === 5  || isExim) && (isHIKAL || isExim) && 
											<div className="wt-100 ht-20 border-bottom-light">
												<div className="fSemibold fs-14 header-medium-color mr-5 ml-10">UOM</div>
											</div>}
											{(leg.rfqType === 5  || isExim) && <div className={Cx("wt-150 ht-20 border-bottom-light", {
												'wt-200': leg.rfqType === 15,
												'wt-150': leg.rfqType == 15
											})}>
												<div className="fSemibold fs-14 header-medium-color mr-5">Ceiling Price</div>
											</div>}
											{/* {leg.rfqType === 5 && <div className="wt-120 ht-20 border-bottom-light">
												<div className="fSemibold fs-14 header-medium-color mr-5">{'Ceiling Price'}</div>
											</div>} */}
											{!(isHIKAL || isExim) && <div className="wt-80 ht-20 border-bottom-light">
												<div className="fSemibold fs-14 header-medium-color mb-5 ml-10">Desc</div>
											</div>}
										</Fragment> :
										<Fragment>
									 	{isDedicated> 0 && !['999','872'].includes(leg.companyId) && <div className="wt-100 ht-20 border-bottom-light">
												<div className="fSemibold fs-14 header-medium-color mb-5 ml-10">KM Range</div>
											</div>}
											{isDedicated> 0 && <div className={"ht-20 wt-100 border-bottom-light"}>
												<div className="fSemibold fs-14 header-medium-color mb-5 ml-10">Ceiling Price</div>
											</div>}
										</Fragment>}

										{isDedicated> 0  && <div className={Cx("ht-20 border-bottom-light", {
											'ml--30': (leg.rfqType === 5  || isExim),
											'wt-100': !(isHIKAL || isExim) || isChargeEdit,
											'wt-200': (isHIKAL || isExim) && !isChargeEdit
										})}>
										<div className="fSemibold fs-14 header-medium-color mb-5 ml-30">Bid Rate</div>
									</div>}

									{(leg.rfqType === 3 || (isHIKAL || isExim)) && !isChargeEdit &&
										<div className="wt-150 ht-20 border-bottom-light">
											<div className={Cx("fSemibold fs-14 header-medium-color mb-5 ml-10", {
												'ml-10': !(isHIKAL || isExim),
												'ml-30': (isHIKAL || isExim)
											})}>Challenge Price</div>
										</div>
									}
								</div>
							</div>
							<div className="flex mb-10">
								<div>
									{
										leg.rfqType === 3 && leg.legs && leg.legs.length > 0 && (leg.legs[0].secondaryModeOtherCharges || []).map((hc, hcindex) => {
											return (
												<Fragment>
													<div key={`hc_${hcindex}`} className="flex mb-10">
														<div className="wt-20 fs-14">
															{
																hcindex + 1
															}
														</div>
														<div className="wt-150 ml-5">
															<div className="fs-14">{hc.cost_charges_description}</div>
														</div>

														{!['999','872'].includes(leg.companyId) && <div className="wt-100">
															{/* {(hc.from_range >=0 && hc.to_range) ? <div className="fs-14 ml-10">{hc.from_range} - {hc.to_range}</div>
															: <div className="fs-14 ml-10"></div>}
															{((hc.from_range >= 0) && !hc.to_range) && <div className="fs-14 ml-10">{hc.from_range}</div>} */}
                                             {<div className="fs-14 ml-10">{this.getSlabValue(hc.from_range, hc.to_range)}</div>}
														</div>}
														<div className="wt-100">
															{hc.ceiling_price ? 
															<div className="fs-14 ml-10">₹{hc.ceiling_price}</div>
																: <div className="fs-14 ml-10"></div>}
														</div>

														{/* <div className="wt-150">
                                                <div className="fs-14 ml-50">{hc.cost_charges_qbr}</div>
                                             </div> */}

														{isChargeEdit ? <div className="wt-100 flex ml-10">
															₹ <Input className="handling-Input no-border mt--2 handling-charges-ip" placeholder="My Bid"
																value={hc.cost_charges_qbr || ''}
																onChange={(e) => this.onHCChange(hcindex, e.target.value, e.target.name, true)}
																name="cost_charges_qbr" />
														</div> :
															<div className="wt-100 flex ml-10">
																<div className="fs-14">{hc.cost_charges_qbr}</div>
															</div>
														}

														{
															isRilCPForm &&
															<div className="wt-150 challenge-color flex-1 fs-14 lh-15p pr">
																{
																	hc.variable_challenge_price &&
																	formatToINR(hc.variable_challenge_price) || ''}
																{
																	formatToINR(hc.variable_challenge_price) && hc.variable_challenge_price !== 0 &&
																	hc.variable_challenge_price < hc.cost_charges_qbr &&
																	hc.variable_challenge_price !== undefined &&
																	hc.cp_variable_state === CHALLENGE_PRICE_SENT &&
																	// rfq.challengePriceWithAcceptOrReject &&
																	// lineItem.counterStatus !== COUNTER_ACCEPT &&
																	leg.isAccept !== true && leg.isLoiWithCPSent !== true &&

																	// !this.state.hideChallengePriceApprovals.includes(lineItem.id) &&
																	<React.Fragment>
																		<AcceptIcon className="wt-20 ht-20 ml-5 curP z-100" onClick={() => this.handleChallengePrice('accept', hc, leg.id, 'variable_cost_accept_reject_list')} />
																		<RejectIcon className="wt-20 ht-20 ml-5 curP z-100" onClick={() => this.handleChallengePrice('reject', hc, leg.id, 'variable_cost_accept_reject_list')} />
																	</React.Fragment>
																}
															</div>
														}

													</div>
												</Fragment>

											)

											// }
										})
                              // : 'No Slabs Added'
                              
                           }

									{
										// leg.legs && leg.legs.length > 0 && leg.legs[0].multiModeHeadingCharges && 
										leg.legs && leg.legs.length > 0 && (leg.legs[0].multiModeHeadingCharges || []).map((hc, hcindex) => {
											if (hc.headingChargesValue) {
												const costUnit = COST_TYPE.find(pricingBasis => { return parseInt(hc.headingChargesUnit) === pricingBasis.value });
												const hcCurrencyType = (currencyTypes || []).find(el => el.currency_type == hc.headingChargesUnit) || {};
												return (<>
													<Fragment>
														<div key={`hc_${hcindex}`} className="flex flex-middle mb-10">
															{(leg.rfqType === 2 || leg.rfqType === 3) && <div className="wt-20 fs-14">
																{
																	hcindex + 1
																}
															</div>}
															{/*<div className="wt-150 ml-5">
																<div className="fs-14">{hc.headingChargesValue}</div>
															</div>*/}
															{leg.rfqType === 3 && <div className="wt-150 ml-5">
																<div className="fs-14">{hc.headingChargesValue}</div>
															</div> 
															}
															{(leg.rfqType === 2 || leg.rfqType === 5 || isExim) && 
															<div className={(rfq.shippingType == 1 && [13,14].includes(leg.rfqType)) ?  "wt-250 mr-5 fs-14"  : ([15].includes(leg.rfqType) ? "wt-200 mr-5 fs-14" : "wt-80 mr-5 fs-14")}>
																<div className={leg.rfqType === 15 ? '' : "truncate-long-text"} title={this.getHeadingChargesLabel(hc, leg)}>{this.getHeadingChargesLabel(hc, leg)}{hc.headingCharge_mandatory_for_bidding && <span className={'error-color fs-16 fBold'}>*</span>}</div>
															</div> }
															<div className="wt-20"></div>
															{leg.rfqType === 3 &&
																<Fragment>
																{!['999', '872'].includes(leg.companyId) && <>
																{(hc.from_range && hc.to_range) ?
																	<div className="wt-100">
																		<div className="fs-14 ml-10">{hc.from_range} - {hc.to_range}</div>
																	</div> : <div className="wt-100"></div>
																}</>}
																	<div className="wt-100">
																	{hc.ceiling_price ? 
																		<div className="fs-14 ml-10">₹{hc.ceiling_price}</div> : <div className="fs-14 ml-10"></div>}
																	</div>
																</Fragment>
															}


															{leg.rfqType !== 3 && <div className={(leg.rfqType === 5  || isExim) ? "wt-65 handling-select fs-14 ml--20" :"wt-65 handling-select fs-14"}>
																{/* {costUnit && Object.keys(costUnit).length > 0 ? <span>{costUnit.name}</span> : <span className="fs-14 ml-10"> - </span>} */}
																{hcCurrencyType && Object.keys(hcCurrencyType).length > 0 ? <span>{hcCurrencyType.currency_name}</span> : <span className="fs-14 ml-10"> - </span>}
															</div>}
															{leg.rfqType === 5 && leg.rfqServiceType === 5 && !(isHIKAL || isExim) && <div className={"wt-100 handling-select fs-14 break-word"}>
																<span className="mr-2">{hc.headingChargesBusinessVolumeValue}</span>{" "}<span>{hc.headingChargesBusinessVolumeUnitName}</span>
															</div>}
															{(leg.rfqType === 5  || isExim) && (isHIKAL || isExim) && <div className={"wt-100 handling-select fs-14 break-word"}>
																<span className="mr-2">{hc.headingChargesBusinessVolumeValue}</span>{" "}<span>{hc.headingChargesBusinessVolumeUnitName}</span>
															</div>}
															{
																(leg.rfqType === 5  || isExim) && 
																<div className={Cx("fs-14", {
																	'wt-200': leg.rfqType === 15,
																	'wt-150': leg.rfqType == 15
																})}>
																	<div className={Cx("inBlock mr-5", {
																		'wt-90': leg.rfqType === 15,
																		'wt-70': leg.rfqType !== 15
																	})}>{hc.original_headingChargesCp_inr && `₹${Number(hc.original_headingChargesCp_inr).toFixed(2)}`}</div>
																		{hcCurrencyType.currency_type !== 1 && <span className={Cx("inBlock mr-5", {
																		'wt-90': leg.rfqType === 15,
																		'wt-70': leg.rfqType !== 15
																	})}>{hc[`original_headingChargesCp_${hcCurrencyType.currency_type === 3 ? 'secondary' : 'usd'}`] && `${hcCurrencyType.currency_type !== 1 && hcCurrencyType.currency_symbol || '$'}${Number(hc[`original_headingChargesCp_${hcCurrencyType.currency_type === 3 ? 'secondary' : 'usd'}`]).toFixed(2)}`}</span>}
																</div>
															}
															{/* {
																(leg.rfqType === 5) &&
																<div className="wt-120 mr-5 ml--10 fs-14">
																	<span className="ml-5">{hc[`original_headingChargesCp_${hcCurrencyType.currency_type === 3 ? 'secondary' : 'usd'}`] && `${hcCurrencyType.currency_type !== 1 && hcCurrencyType.currency_symbol || '$'}${Number(hc[`original_headingChargesCp_${hcCurrencyType.currency_type === 3 ? 'secondary' : 'usd'}`]).toFixed(2)}`}</span>
																</div>
															} */}

															{leg.rfqType !== 3 && !(isHIKAL || isExim) &&
																<div className="wt-80 ml-5">
																	<div className="fs-14 truncate-long-text" title={hc.headingChargesDescription}>{hc.headingChargesDescription}</div>
																</div>}

															{isChargeEdit ?
																(<div className={Cx("flex", {
																	'ml-10': leg.rfqType === 3,
																	'wt-200': (leg.rfqType === 5  || isExim),
																	'wt-100': leg.rfqType !== 5
																})}>
																	₹ <Input className={Cx("handling-Input no-border mt--2 handling-charges-ip", {
																		'disabled ht-25': ((leg.rfqType === 5  || isExim) && [2,3].includes(Number(hc.headingChargesUnit)))
																	})} placeholder="My Bid"
																		value={(leg.rfqType === 5  || isExim) ? (hc.headingChargesCp_inr && [2,3].includes(Number(hc.headingChargesUnit)) && Number(hc.headingChargesCp_inr).toFixed(2) || hc.headingChargesCp_inr) : hc.headingChargesBudget}
																		onChange={(e) => {
																			if (e.target.value == "0") return;
																			this.onHCChange(hcindex, e.target.value, e.target.name)
																		}} 
																		name={(leg.rfqType === 5 || isExim) ? "headingChargesCp_inr": "headingChargesBudget"} 
																		disabled={(leg.rfqType === 5  || isExim) && Number(hc.headingChargesUnit) === 2}
																		type="number"
																		onKeyDown={e => {

																			if (["e", "E", "+", "-"].includes(e.key)) e.preventDefault();
																			if (e.key == "0" && e.currentTarget.value.length === 0) {
																				e.preventDefault();
																			}
																		}}
																		/>
																		
																	{(leg.rfqType === 5  || isExim) && hcCurrencyType.currency_type !== 1 && <div className="flex">
																		{hcCurrencyType.currency_type !== 1 &&  hcCurrencyType.currency_symbol || '$' }<Input className={Cx("handling-Input no-border mt--2 handling-charges-ip", {
																			'disabled ht-25': ((leg.rfqType === 5  || isExim) && Number(hc.headingChargesUnit) === 1)
																		})} placeholder="My Bid"
																			value={hc[`headingChargesCp_${hcCurrencyType.currency_type === 3 ? 'secondary' : 'usd'}`] && Number(hc.headingChargesUnit) === 1 && Number(hc[`headingChargesCp_${hcCurrencyType.currency_type === 3 ? 'secondary' : 'usd'}`]).toFixed(2) || hc[`headingChargesCp_${hcCurrencyType.currency_type === 3 ? 'secondary' : 'usd'}`]}
																			onChange={(e) => {
																				if (e.target.value == "0") return;
																				this.onHCChange(hcindex, e.target.value, e.target.name)
																			}} 
																			name={`headingChargesCp_${hcCurrencyType.currency_type === 3 ? 'secondary' : 'usd'}`}
																			disabled={(leg.rfqType === 5  || isExim) && Number(hc.headingChargesUnit) === 1}
																			type="number"
																			onKeyDown={e => {
																				
																				if (["e", "E", "+", "-"].includes(e.key)) e.preventDefault();
																				if (e.key == "0" && e.currentTarget.value.length === 0) {
																					e.preventDefault();
																				}
																			}}
																		/></div>
																	}
																	{hc.isNewlyAdded && <TrashIcon className="error-color ht-20 wt-20 curP mr-5" onClick={() => this.deleteCostHead(hcindex)}/>}
																</div>) :
																<div className={Cx("wt-100 flex ml--10", {
																	'ml--10': (leg.rfqType === 5  || isExim),
																	'ml-5': !(leg.rfqType === 5 || isExim),
																	'wt-100': !(isHIKAL || isExim),
																	'wt-200': (isHIKAL || isExim)
																})}>
																	{hc.headingChargesBudget && !(leg.rfqType == 5 || isExim) && <div className="fs-14" title={`₹${hc.headingChargesBudget}`}>₹{hc.headingChargesBudget && Number(hc.headingChargesBudget).toFixed(2)}</div> || null}
																	{(leg.rfqType === 5  || isExim) && 
																	<Fragment>
																		{hc.headingChargesCp_inr && <div className="fs-14 ml-5" title={`₹${hc.headingChargesCp_inr}`}>₹{hc.headingChargesCp_inr && Number(hc.headingChargesCp_inr).toFixed(2)}</div> || null}
																		{hcCurrencyType.currency_type !== 1 && hc[`headingChargesCp_${hcCurrencyType.currency_type === 3 ? 'secondary' : 'usd'}`] && <div className="fs-14 ml-5 mt-3" title={`${hcCurrencyType.currency_type !== 1 && hcCurrencyType.currency_symbol || '$'}${hc[`headingChargesCp_${hcCurrencyType.currency_type === 3 ? 'secondary' : 'usd'}`]}`}>{hcCurrencyType.currency_type !== 1 && hcCurrencyType.currency_symbol || '$'}{hc[`headingChargesCp_${hcCurrencyType.currency_type === 3 ? 'secondary' : 'usd'}`] && Number(hc[`headingChargesCp_${hcCurrencyType.currency_type === 3 ? 'secondary' : 'usd'}`]).toFixed(2) || ''}</div> || null}
																	</Fragment>}
																</div>
															}
															{
																isRilCPForm &&
																<div className={Cx("wt-250 challenge-color flex-1 fs-14 lh-15p pr mt-3", {
																	"wt-250": !(leg.rfqType == 5 || isExim),
																	"wt-300": (leg.rfqType === 5  || isExim)
																})}>
																	{(leg.rfqType === 5  || isExim) ?
																	<span>
																		<span className="ml-20">{hc.other_cost_challenge_price_inr && `₹${Number(hc.other_cost_challenge_price_inr).toFixed(2)}` || ''}</span>
																		{hcCurrencyType.currency_type !== 1 && <span className="ml-5">{(hc[`other_cost_challenge_price_${hcCurrencyType.currency_type === 3 ? 'secondary': 'usd'}`]) && `${hcCurrencyType.currency_symbol || '$'}${Number(hc[`other_cost_challenge_price_${hcCurrencyType.currency_type === 3 ? 'secondary': 'usd'}`]).toFixed(2)}` || ''}</span>}
																	</span>
																	:
																	<span>
																		{(hc.other_challenge_price) && formatToINR(hc.other_challenge_price) || ''}
																	</span>
																	}
																	{
																		((leg.rfqType === 5  || isExim) ? 
																		formatToINR(hc.other_cost_challenge_price_inr) && hc.other_cost_challenge_price_inr !== 0 &&
																		hc.other_cost_challenge_price_inr < hc.headingChargesCp_inr &&
																		hc.other_cost_challenge_price_inr !== undefined &&
																		hc.cp_other_state === CHALLENGE_PRICE_SENT &&
																		// rfq.challengePriceWithAcceptOrReject &&
																		// lineItem.counterStatus !== COUNTER_ACCEPT &&
																		leg.isAccept !== true && leg.isLoiWithCPSent !== true
																		:
																		formatToINR(hc.other_challenge_price) && hc.other_challenge_price !== 0 &&
																		hc.other_challenge_price < hc.headingChargesBudget &&
																		hc.other_challenge_price !== undefined &&
																		hc.cp_other_state === CHALLENGE_PRICE_SENT &&
																		// rfq.challengePriceWithAcceptOrReject &&
																		// lineItem.counterStatus !== COUNTER_ACCEPT &&
																		leg.isAccept !== true && leg.isLoiWithCPSent !== true) &&

																		// !this.state.hideChallengePriceApprovals.includes(lineItem.id) &&
																		<React.Fragment>
																			<AcceptIcon className="wt-20 ht-20 ml-5 curP z-100 mt--10" onClick={() => this.handleChallengePrice('accept', hc, leg.id, 'other_cost_accept_reject_list')} />
																			<RejectIcon className="wt-20 ht-20 ml-5 curP z-100 mt--10" onClick={() => this.handleChallengePrice('reject', hc, leg.id, 'other_cost_accept_reject_list')} />
																		</React.Fragment>
																	}
																</div>
															}

														</div>
													</Fragment>

												</>)

											}
										})
										|| 'No heading charge added'
									}
								</div>
									
								</div>
							</div>
							{(leg.rfqType === 2 || ([5,15].includes(leg.rfqType)  || (rfq.shippingType !== 1 && [13,14].includes(leg.rfqType)))) && isChargeEdit && leg.legs[0] && <div className={Cx("col-3 flex shipping-line", {
								'ml-175': ![15].includes(leg.rfqType) 
							})}>
									<div className="wt-320">
									{((leg.rfqType === 5 && isHIKAL) || isExim) &&
										<>
										{/* <div className="pr-5 pt-15 flex pr">
											<div className="wt-150 mt--15 flex postbid-label">
											<FormInput
												value={leg.legs[0].shippingLineName}
												placeholder={isHIKAL ? ((rfq.rfqDetails || {}).serviceCategoryType === 1 ? 'Shipping Line' : 'Air Line') : 'Shipping Line: '}
												name="shippingLineName"
												onChange={(e) => {
													const { leg } = this.state;
													const { name, value } = e.currentTarget;
													leg.legs[0][name] = value;
													this.setState({  leg });
												 }}
												className="col-1 fs-14 no-border"
												noTransition={true}
												step="any"
												containerClassName="no-transition-container"
												required={isHIKAL && (rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType == 4}
											/>
											</div>
										</div> */}
										<div className={'fs-12 fRegular mb-5'}>{(rfq.rfqDetails || {}).serviceCategoryType === 1 ? 'Shipping Line' : 'Air Line'}<sup>*</sup></div>
										<Dropdown
											items={(rfq.rfqDetails || {}).serviceCategoryType === 1 ? ((seaAndAirLines || {}).sea || []) : ((seaAndAirLines || {}).air || []) || []}
											selectedItem={((rfq.rfqDetails || {}).serviceCategoryType === 1 ? ((seaAndAirLines || {}).sea || []) : ((seaAndAirLines || {}).air || [])).find(liner => liner.name === leg.legs[0].shippingLineName) || null}
											name="shippingLine"
											displayKey="name"
											label=""
											noBorder={true}
											className="wt-180 border-light br-5 fs-14 mb-5"
											onSelect={(value) => {
												const { leg } = this.state;
												leg.legs[0]['shippingLineName'] = value.name;
												leg.legs[0]['linerId'] = value.id;
												this.setState({ leg },this.updateDataList);
											}}
											searchEnabled={true}
										/>
									</>
									}
									{(isAdani ? leg.rfqType !== 15 : true) && <>
										<div className={'fSemibold fs-14 header-medium-color mb-5'} title={leg.legs[0].poLoading && leg.legs[0].poLoading.location || ''}>Point Of Loading</div>
										<div className={Cx({'disabled' : !isChargeEdit })} title={leg.legs[0].poLoading && leg.legs[0].poLoading.location || ''}>
											<PlacesAutoComplete
												setLocation={(location) => {
													const { leg } = this.state;
													leg.legs[0].poLoading = location;
													this.setState({ leg }, this.updateDataList)
												}}
												value={leg.legs[0].poLoading && leg.legs[0].poLoading.location || ''}
											/>
										</div>
										</>}
										{(leg.rfqType === 5  || isExim) && <Fragment>
											<div className={'fSemibold fs-14 header-medium-color mb-5 mt-5'}>Estimated Time Of Departure {isAdani && <sup>*</sup>}</div>
											<div className={Cx('flex post-bid',{'disabled' : !isChargeEdit })}>
												<SingleDatePicker
													noBorder={true}
													displayFormat={"DD MMM YYYY"}
													hideKeyboardShortcutsPanel={true}
													placeholder={"ETD"}
													numberOfMonths={1}
													// date={Moment(this.state.biddingEnd ? this.state.biddingEnd : new Date())}
													date={leg.legs[0].estimatedTimeOfDepartureDate && Moment(leg.legs[0].estimatedTimeOfDepartureDate) || null}
													onDateChange={(dateETD) => {
														const { leg } = this.state;
														if (!dateETD) return;

														const etdCandidate =
															dateETD.format("YYYY-MM-DD") +
															" " +
															Moment(
																leg.legs[0].estimatedTimeOfDepartureDate || new Date()
															).format("HH:mm");

														const etd = new Date(etdCandidate).getTime();
														leg.legs[0].estimatedTimeOfDepartureDate = etd;

														
														if (
															leg.legs[0].estimatedTimeOfArrivalDate &&
															leg.legs[0].estimatedTimeOfArrivalDate <= etd
														) {
															leg.legs[0].estimatedTimeOfArrivalDate = null;
															
														}

														this.setState({ leg }, this.updateDataList);
													}}
													focused={this.state.focusedETD} 
													onFocusChange={({ focused }) => { this.setState({ focusedETD: focused }) }} 
												/>
												<TimePicker
													showSecond={false}
													value={leg.legs[0].estimatedTimeOfDepartureDate && Moment(leg.legs[0].estimatedTimeOfDepartureDate) || null}
													className="ht-40 wt-80 border-status-bar br-5"
													onChange={(dateETD) => {
													// const date = Moment(this.state.biddingEnd ? this.state.biddingEnd : new Date()).format('YYYY-MM-DD') + ' ' + biddingEnd.format('HH:mm')
														const { leg } = this.state;
														const date = Moment(leg.legs[0].estimatedTimeOfDepartureDate ? leg.legs[0].estimatedTimeOfDepartureDate : dateETD).format('YYYY-MM-DD') + ' ' + dateETD.format('HH:mm')
														leg.legs[0].estimatedTimeOfDepartureDate = date;
														this.setState({ leg }, this.updateDataList)
													}}
													placeholder={'Time'}
													format={'h:mm a'}
													use12Hours
												/>
											</div>
										</Fragment>}
										{isAdani && rfq.type === 15 && (<>
										<div className={'fs-12 fRegular mb-5'}>{'Vessel Routing Type'}<sup>*</sup></div>
										<Dropdown
											items={VESSEL_ROUTING_TYPES}
											selectedItem={VESSEL_ROUTING_TYPES.find(el => el.name === leg.legs[0].vesselRoutingType) || null}
											name="vesselRoutingType"
											displayKey="name"
											label=""
											noBorder={true}
											className="wt-180 border-light br-5 fs-14 mb-5"
											onSelect={(value) => {
												const { leg } = this.state;
												leg.legs[0]['vesselRoutingType'] = value.name;
												this.setState({ leg },this.updateDataList);
											}}
											searchEnabled={true}
										/>
											<div>
												<div className={'fSemibold fs-14 header-medium-color mb-5 mt-5'}>
													Remarks
												</div>
												<Input
													value={leg.legs[0].provider_bid_remarks || ""}
													name="provider_bid_remarks"
													placeholder="Please Enter Remarks"
													onChange={(e) => {
														const { leg } = this.state;
														leg.legs[0]['provider_bid_remarks'] = e.target.value;
														this.setState({ leg }, this.updateDataList);
													}}
												/>
											</div>
									</>)}
									</div>
									<div className="wt-300 ml-10">
										{((leg.rfqType === 5 && isHIKAL) || isExim) && <div className="pr-5 pt-15 flex postbid-label pr ht-60">
											<div className="wt-150 mt-5 flex">
												<div className="wt-70">
												<FormInput
													type="number"
													value={leg.legs[0].containerFreeDay}
													placeholder={(isHIKAL || isExim) ? `${((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType == 4 ) ? `Container ${isAdani ? 'Free Days' : 'Shipment'} ${leg.legs[0].containerFree && `(${leg.legs[0].containerFree} ${leg.legs[0].containerFeeDaysHours || ''})`}` : `Storage Free Days ${leg.legs[0].containerFree && `(${leg.legs[0].containerFree} ${leg.legs[0].containerFeeDaysHours || ''})`}`}` : `Container Free ${leg.legs[0].containerFree && `(${leg.legs[0].containerFree} ${leg.legs[0].containerFeeDaysHours || ''})`}`}
													name="containerFreeDay"
													onChange={(e) => {
														const { name, value } = e.currentTarget;
														const { leg } = this.state;
														leg.legs[0][name] = value;
														this.setState({ leg }, this.updateDataList)
													 }}
													className="col-1 fs-14 no-border"
													noTransition={true}
													step="any"
													containerClassName="no-transition-container"
													required={(isHIKAL || isExim)}
												/>
												</div>
												<Dropdown
												items={TAT_UNITS_LAT}
												selectedItem={leg.legs[0].containerDaysHours &&  TAT_UNITS_LAT.find(TATunit => TATunit.value === leg.legs[0].containerDaysHours) || null}
												name="containerDaysHours"
												displayKey="name"
												label=""
												noBorder={true}
												className="wt-60"
												onSelect={(value) => {
													const { leg } = this.state;
													leg.legs[0]['containerDaysHours'] = value.value;
													this.setState({ leg }, this.updateDataList)
												 }}
												/>
											</div>
										</div>}
										{(isAdani ? leg.rfqType !== 15 : true ) && <> 
											<div className={'fSemibold fs-14 header-medium-color mb-5 mt-5'} title={leg.legs[0].poDestination && leg.legs[0].poDestination.location || ''}>Point Of Destination</div>
											<div className={Cx({'disabled' : !isChargeEdit })}>
												<PlacesAutoComplete
													setLocation={(location) => {
														const { leg } = this.state;
														leg.legs[0].poDestination = location;
														this.setState({ leg }, this.updateDataList)
													}}
													value={leg.legs[0].poDestination && leg.legs[0].poDestination.location || ''}
												/>
											</div>
										</>}
										{(leg.rfqType === 5  || isExim) && <Fragment>
											<div className={'fSemibold fs-14 header-medium-color mb-5 mt-10'}>Estimated Time Of Arrival {isAdani && <sup>*</sup>}</div>
											<div className={Cx('flex post-bid',{'disabled' : !isChargeEdit })}>
												<SingleDatePicker
													noBorder={true}
													displayFormat={"DD MMM YYYY"}
													hideKeyboardShortcutsPanel={true}
													placeholder={"ETA"}
													numberOfMonths={1}
													date={
														leg.legs[0].estimatedTimeOfArrivalDate
															? Moment(leg.legs[0].estimatedTimeOfArrivalDate)
															: null
													}
													onDateChange={(dateETA) => {
														const { leg } = this.state;
														if (!dateETA) return;

														const etd = leg.legs[0].estimatedTimeOfDepartureDate
															? Moment(leg.legs[0].estimatedTimeOfDepartureDate)
															: null;

														
														const etaCandidate =
															dateETA.format("YYYY-MM-DD") +
															" " +
															Moment(
																leg.legs[0].estimatedTimeOfArrivalDate ||
																leg.legs[0].estimatedTimeOfDepartureDate ||
																new Date()
															).format("HH:mm");

														const eta = new Date(etaCandidate).getTime();

														
														if (etd && eta <= etd.valueOf()) {
															return; 
														}

														leg.legs[0].estimatedTimeOfArrivalDate = eta;
														this.setState({ leg }, this.updateDataList);
													}}
													focused={this.state.focusedETA}
													onFocusChange={({ focused }) => this.setState({ focusedETA: focused })}
													isOutsideRange={(day) =>
														leg.legs[0].estimatedTimeOfDepartureDate
															? day.isBefore(
																Moment(leg.legs[0].estimatedTimeOfDepartureDate),
																"day"
															)
															: false
													}
												/>


												<TimePicker
													showSecond={false}
													value={
														leg.legs[0].estimatedTimeOfArrivalDate
															? Moment(leg.legs[0].estimatedTimeOfArrivalDate)
															: null
													}
													className="ht-40 wt-80 border-status-bar br-5"
													onChange={(dateETA) => {
														const { leg } = this.state;
														const etd = leg.legs[0].estimatedTimeOfDepartureDate
															? Moment(leg.legs[0].estimatedTimeOfDepartureDate)
															: null;

														if (!dateETA) return;

														
														const etaCandidate =
															Moment(
																leg.legs[0].estimatedTimeOfArrivalDate ||
																leg.legs[0].estimatedTimeOfDepartureDate ||
																dateETA
															).format("YYYY-MM-DD") +
															" " +
															dateETA.format("HH:mm");

														const eta = new Date(etaCandidate).getTime();

														
														if (etd && eta <= etd.valueOf()) {
															alert("ETA must be greater than ETD");
															return;
														}

														leg.legs[0].estimatedTimeOfArrivalDate = eta;
														this.setState({ leg }, this.updateDataList);
													}}
													placeholder={"Time"}
													format={"h:mm a"}
													use12Hours
												/>
											</div>
										</Fragment>}

										{isAdani && isExim &&  <div>
												<div className={'fSemibold fs-14 header-medium-color mb-5 mt-5'}>
													Transit Days
												</div>
												{/* <Input
													value={leg.legs[0].provider_tat_time || ""}
													name="provider_bid_remarks"
													placeholder="Please Enter Remarks"
													onChange={(e) => {
														const { leg } = this.state;
														leg.legs[0]['provider_tat_time'] = e.target.value;
														this.setState({ leg }, this.updateDataList);
													}}
												/> */}
												<div className="wt-150 mt-5 flex">
												<div className="wt-70">
												<FormInput
													type="number"
													value={leg.legs[0].provider_tat_time}
													placeholder={"Transit Days"}
													name="provider_tat_time"
													onChange={(e) => {
														const { leg } = this.state;
														leg.legs[0]['provider_tat_time'] = e.target.value;
														this.setState({ leg }, this.updateDataList);
													}}
													className="col-1 fs-14 no-border"
													noTransition={true}
													step="any"
													containerClassName="no-transition-container"
												/>
												</div>
												<div className="mt-5">Days</div>
											</div>
											</div>}
									</div>
								</div>
							} 
							{
								(leg.rfqType === 2 || [5,15].includes(leg.rfqType) || (rfq.shippingType !== 1 && [13,14].includes(leg.rfqType))) && !isChargeEdit && 
								<div className="col-3 ml-175 fs-14">
									{(isAdani ? leg.rfqType !== 15 : true) && <>
									<div className="pv-5 break-word" title={leg.legs[0] && leg.legs[0].poLoading && leg.legs[0].poLoading.location || ''}><span className="label-color fSemibold">Point Of Loading: </span><span className={'fBold'}>{leg.legs[0] && leg.legs[0].poLoading && leg.legs[0].poLoading.location || ''}</span></div>
									<div className="pv-5 break-word" title={leg.legs[0] && leg.legs[0].poDestination && leg.legs[0].poDestination.location || ''}><span className="label-color fSemibold">Point Of Destination: </span><span className={'fBold'}>{leg.legs[0] && leg.legs[0].poDestination && leg.legs[0].poDestination.location || ''}</span></div>
									</>}
									{(leg.rfqType === 5 || isExim) && <Fragment>
										<div className="pv-5 break-word" title={leg.legs[0] && leg.legs[0].shippingLineName || ''}><span className="label-color fSemibold">{(isHIKAL || isExim) ? ((rfq.rfqDetails || {}).serviceCategoryType === 1 ? 'Shipping Line: ' : 'Air Line: ') : 'Shipping Line: '}</span><span className={'fBold'}>{leg.legs[0] && leg.legs[0].shippingLineName || ''}</span></div>
										{isAdani && leg.rfqType == 15 && (<div className="pv-5 break-word" title={leg.legs[0] && leg.legs[0].vesselRoutingType || ''}><span className="label-color fSemibold">{'Vessel Routing Type'}</span><span className={'fBold'}>{leg.legs[0] && leg.legs[0].vesselRoutingType || ''}</span></div>)}
									    {isAdani && leg.rfqType == 15 && (<div className="pv-5 break-word" title={leg.legs[0] && leg.legs[0].provider_bid_remarks || ''}><span className="label-color fSemibold">{'Provider Bids Remarks'}</span><span className={'fBold'}>{leg.legs[0] && leg.legs[0].provider_bid_remarks || ''}</span></div>)}
										{(isAdani && leg.rfqType == 15) ? 
										<div className="pv-5"><span className="label-color fSemibold">{'Container Free Days: '}</span><span className={'fBold'}>{leg.legs[0] && leg.legs[0].containerFreeDay || ''} {leg.legs[0] && leg.legs[0].containerDaysHours && (leg.legs[0].containerDaysHours === 1 ? 'Days' : 'Hours')  || ''}</span></div>
										: <div className="pv-5"><span className="label-color fSemibold">{(isHIKAL || isExim) ? `${((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType == 4 ) ? 'Container Shipment: ' : 'Storage Free Days: '}` : 'Container Free: '}</span><span className={'fBold'}>{leg.legs[0] && leg.legs[0].containerFreeDay || ''} {leg.legs[0] && leg.legs[0].containerDaysHours && (leg.legs[0].containerDaysHours === 1 ? 'Days' : 'Hours')  || ''}</span></div>}
										<div className="pv-5"><span className="label-color fSemibold">Estimated Time Of Departure: </span><span className={'fBold'}>{leg.legs[0] && leg.legs[0].estimatedTimeOfDepartureDate && Moment(leg.legs[0].estimatedTimeOfDepartureDate).format("DD MMM YYYY hh:mm a") || null}</span></div>
										<div className="pv-5"><span className="label-color fSemibold">Estimated Time Of Arrival: </span><span className={'fBold'}>{leg.legs[0] && leg.legs[0].estimatedTimeOfArrivalDate && Moment(leg.legs[0].estimatedTimeOfArrivalDate).format("DD MMM YYYY hh:mm a") || null}</span></div>
									</Fragment>}
								</div>
							}
							</div>}
							
							{
								isChargeEdit && ((isHIKAL || isExim) ? this.state.showBreakUp : true) &&
								<div className="ht-30 ml-5 mt-20 ml-500 flex">
									{allowTransporterToAddCostHeadDuringBidding && 
									<button className="ht-30 br-5 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-20" onClick={this.addCostHead}>Add Cost Head</button>}
									<button
										className=
										{Cx("ht-30 br-5 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-20", {
											'notselectable': this.isSubmitDisabled(isExim)
										})}
										onClick={() => {
											for (const singleLeg of leg.legs || []) {
												const headingChargesList = singleLeg.multiModeHeadingCharges || [];
												const baseOrOceanFreightObj = headingChargesList.find(
													item => (item.headingChargesValue === "Base Freight" || item.headingChargesValue === 'Ocean Freight')
												);

												if (this.shouldCheckForBidIncrementTolerence(baseOrOceanFreightObj)) {
													const canBidUpto = this.determineBidIncrementorDecrementpercentageAmount(rfq, baseOrOceanFreightObj);

													if (
														(baseOrOceanFreightObj && Number(baseOrOceanFreightObj.headingChargesCp_inr) > canBidUpto.inr) ||
														(baseOrOceanFreightObj && Number(baseOrOceanFreightObj.headingChargesCp_usd) > canBidUpto.usd)
													) {
														alert(`Base/Ocean Freight can only be bid up to ${canBidUpto.usd} $ or ${canBidUpto.inr} ₹`);
														return;
													}
												}
											}

											if (this.shouldSkipPriceCheckForAwlEximIncoTermsFOB(rfq)) {
												if (!this.state.price || Number(this.state.price) === 0) {
													alert('Please Enter the Price');
													return;
												}
											}
											if (!JSON.parse(localStorage.getItem("termsAndConditionsAccepted"))){
												alert('Please Accept Terms And Conditions');
												return;
											}
											if (isEditBaseRate) {
												// {leg.rfqType === 5 && <div className="fs-14 fBold">$ {usdTotal ? usdTotal.toFixed(5) : 0}</div>}
												if(leg.rfqType === 5 || isExim) {
													if(isAdani && isExim) { 
														if(!(leg.legs[0].estimatedTimeOfArrivalDate && leg.legs[0].estimatedTimeOfDepartureDate)) {
															alert("Please Select the Estimated Time of Depature and Arrival Date");
															return;
														}
														if(!leg.legs[0].vesselRoutingType) {
															alert("Please Select the Vessel Routing Type");
															return;
														}
													}
													const hcList = leg.legs[0] && leg.legs[0].multiModeHeadingCharges || [];
													const hcWithoutBid = hcList.filter(hc => !(hc.headingChargesCp_inr || hc.headingChargesCp_usd));
													const hcWithoutBidforMandatory = hcList.filter(hc => (hc.headingCharge_mandatory_for_bidding && !(hc.headingChargesCp_inr || hc.headingChargesCp_usd)))
													this.setState({
														confirmationPopup: true,
														total,
														totalInrBudget,
														usdTotal,
														confirmText: this.getConfirmationText(hcWithoutBid, hcList.length - 1, hcWithoutBidforMandatory),
														confirmEnabled: isAdani ? (hcWithoutBidforMandatory.length == 0 && ((hcList.length - 1) !== hcWithoutBid.length)) : true
													})
												} else {
													this.props.handlePriceUpdate(
													(includesOtherCharges ? total : this.state.price), 
													{ ...leg, 
														total: total, 
														other_cost: (leg.rfqType === 5  || isExim) ? totalInrBudget : totalBudget , 
														provider_bid_remarks: leg.legs[0].provider_bid_remarks,
														provider_tat_time:leg.legs[0].provider_tat_time ,
														price_usd: legCurrencyType?.currency_type === 2 ? (includesOtherCharges ? usdTotal : this.state.price_usd) : 0,
														price_secondary: legCurrencyType?.currency_type === 3 ? (includesOtherCharges ? usdTotal : this.state.price_usd) : 0,
														price_inr: (includesOtherCharges ? total : this.state.price)
													}, 
													Number(this.state.tatValue), 
													this.state.tatUnit);
												}
											}
												
											// setTimeout(() => {
											//    this.props.updateHandlingCharges({...leg, total: total});
											// }, 2000)
										}}
									>Submit</button>

									{isExim && (!currencyDetails || currencyDetails.length === 0) && <span className={'error-color fs-16 mt-5  fBold'}>Conversion error occurred please reload to try again!</span>}
								</div>
                     	}	
                     
						</div>
                  
					</div>
              
				</div>
				{this.state.confirmationPopup &&
					<ConfirmationPopup 
						text={this.state.confirmText}
						onCancel={this.onCancel}
						onConfirm={this.state.confirmEnabled ? this.onConfirm : false}
					/>
				}
				{this.state.openPopup && <Overlay>
					<div className="bg-white box-shadow ph-20 pv-20 br-100 pr-40">
						<div className="mb-20 tleft header-medium-color fSemibold fs-18">Cargo Particulars Details
						<span className="pr-10 fRight curP" id='close' onClick={ () => this.setState({openPopup: false})}>x</span> 
                	</div>
               		<div className="courier-table mt-10">
						<table cellPadding={0} cellSpacing={0} width="100%">
						<thead>
							<tr>
								<th>Sl No.</th>
								{/* <th>Metric System</th> */}
								<th>Cargo Packing Type</th>
								<th>No. of Units</th>
								<th width="60">{'Length'}</th>
								<th width="60">{'Breadth'}</th>
								<th width="60">{'Height'}</th>
								<th>UOM</th>
								<th>Net Weight</th>
								<th>Gross Weight</th>
								<th>{((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType === 5) ? 'Unit Volume (CBM)' : 'Volume Weight'}</th>
								<th>{((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType === 5) ? 'Chargeable Volume (CBM)' : `Chargeable Weight ${leg.metricSystem === 1 ? 'kgs' : 'lb'}`}</th>
							</tr>
						</thead>
						<tbody>
							{(leg.cargoParticularList || []).map((cParticular, index) =>{
								totalChargableWeight += Number(cParticular.chargableWeight || 0);
								totalGrossWeight += Number(cParticular.grossWeight || 0);
								totalNetWeight += Number(cParticular.netWeight || 0);
								totalVolumeWeight += Number(cParticular.volumeWeight || 0);
							return(<tr>
								<td style={{ 'borderBottom': '1px solid grey'}}>{index + 1}</td>
								{/* <td style={{ 'borderBottom': '1px solid grey'}}>
									<Dropdown 
										onSelect={this.onSelectCargoParticulars.bind(this, 'metricSystem', index)}
										items={METRIC_SYSTEM} 
										selectedItem={METRIC_SYSTEM.find((metric)=> {
											return metric.value === (cParticular.metricSystem || {}).value
										})} 
										label="Select" 
										displayKey="name"
									/>
								</td> */}
								<td style={{ 'borderBottom': '1px solid grey'}}>{cParticular.cargoPackingType}</td>
								<td style={{ 'borderBottom': '1px solid grey'}}>{cParticular.quantity}</td>
								<td style={{ 'borderBottom': '1px solid grey'}}>{cParticular.length}</td>
								<td style={{ 'borderBottom': '1px solid grey'}}>{cParticular.breadth}</td>
								<td style={{ 'borderBottom': '1px solid grey'}}>{cParticular.height}</td>
								<td style={{ 'borderBottom': '1px solid grey'}}>{(cParticular.uom || {}).name}</td>
								<td style={{ 'borderBottom': '1px solid grey'}}>{cParticular.netWeight}</td>
								<td style={{ 'borderBottom': '1px solid grey'}}>{cParticular.grossWeight}</td>
								<td style={{ 'borderBottom': '1px solid grey'}}>{cParticular.volumeWeight}</td>
								<td style={{ 'borderBottom': '1px solid grey', 'borderRight': '1px solid grey'}}>{cParticular.chargableWeight}</td>
							</tr>)})}
							<tr>
								<td colSpan="7" style={{ 'borderBottom': '1px solid grey'}}>Total</td>
								<td style={{ 'borderBottom': '1px solid grey'}}><span>{totalNetWeight}</span></td>
								<td style={{ 'borderBottom': '1px solid grey'}}><span>{totalGrossWeight}</span></td>
								<td style={{ 'borderBottom': '1px solid grey'}}><span>{totalVolumeWeight}</span></td>
								<td style={{ 'borderBottom': '1px solid grey','borderRight': '1px solid grey'}}><span>{totalChargableWeight}</span></td>
							</tr>
						</tbody>
						</table>
					</div>
					</div>
					</Overlay>}
					{this.state.openCostHeadModal &&  
						<AddCostHeadPopup 
							onCancel={this.onCancelCostHeadModal}
							onAdd={this.onClickAddCost}
							onSelectCostHead={this.onSelectCostHead}
							costHeadsOptions={this.state.costHeadsOptions}
							selectedCostHeads={this.state.selectedCostHeads}
						/>}
			</div>
		)

	}
}


export default connect()(HandlingCharges);
